/* eslint-disable array-callback-return */
/* eslint-disable jsx-a11y/anchor-is-valid */
/* eslint-disable no-script-url */
/* eslint-disable react/jsx-no-target-blank */
import React, { Component } from 'react';
import trackingService from '../../services/trackingService';
import DocumentDescriptor from '../../components/DocumentDescriptor';
import KeyTakeaways from '../../components/KeyTakeaways';
import { infoIcn } from '../../assets'
import GenerateArrayStrings, { getVarType } from '../../components/GenerateArrayStrings'
import OrderFromRightFind from '../../components/OrderFromRightFind';
import OpenWindow from '../../components/OpenWindow';
import moment from 'moment';
import GreenlightVersion from "../../components/GreenlightVersion";
import { uniq } from 'underscore';
import { a } from "react-router-dom";
import { JJ_Icon_expandIcon, JJ_Icon_collapseIcon, JJ_Icon_Info_RGB } from '../../assets';
import GenAIDocumentDataCitationValue from '../GenAIDocumentResults/GenAIDocumentDataCitationValue';
import GenAIKeyTakeaways from '../../components/GenAIKeyTakeaways';
import GenAIOrderFromRightFind from '../../components/GenAIOrderFromRightFind';
import GenAISummary from '../../components/GenAISummary';
import GenAIGreenlightVersion from '../../components/GenAIGreenlightVersion';
import GenAIEnclosure from '../../components/GenAIEnclosure';
import GenAIDocumentDescriptor from '../../components/GenAIDocumentDescriptor';

// import ActionBar from "../../components/ActionBar";

class DownloadDocumentResultsGenAI extends Component {
  constructor(props) {
    super(props);
    this.state = {
      item: [],
      documentIndex: [],
      collapsed: false,
      appliedFilters: [],
      searchKeyword: '',
      pageSize: "",
      pageNumber: "",
      actionBarCollapsed: false,
      isCollapseAll: false,
      isPubMedHtml: false,
      isFromDownloadHtml: false
    }
    this.width = "";
  }
  componentWillMount() {
    this.setState({
      item: this.props.item,
      documentIndex: this.props.count,
      collapsed: this.props.collapsed,
      appliedFilters: this.props.appliedFilters,
      searchKeyword: this.props.searchKeyword,
      pageSize: this.props.pageSize,
      pageNumber: this.props.pageNumber,
      isCollapseAll: this.props.isCollapseAll,
      isPubMedHtml: this.props.isPubMedHtml ? true : false,
      isFromDownloadHtml: this.props.isFromDownloadHtml ? true : false,
    })
    if (this.props.customWidth < 1000) {
      this.width = "4%"
    }
  }
  componentDidUpdate = (prop) => {
    // console.log(this.props.isCollapseAll)
    if (this.props.collapsed !== this.state.collapsed) {
      this.setState({ collapsed: this.props.collapsed })
    }
    // console.log(prop.isCollapseAll)
    // this.setState({collapsed:prop.isCollapseAll})
    // if(this.props.isCollapseAll !== this.state.collapsed){
    //     console.log(this.props.isCollapseAll)
    //     this.setState({collapsed:this.props.isCollapseAll})
    // }
    // if(this.props.customWidth < 1000){
    //     this.width = "4%"
    // }
  }
  formattedStringArr = (array, fn) => {
    var result = [];
    for (var i = 0; i < array.length; i++) {
      var mapping = fn(array[i]);
      result = result.concat(mapping);
    }
    return result;
  }
  divider = () => {
    return (
      <div className="gen-ai-key-takeaways-divider"></div>
    )
  }
  textFormatter = (data) => {
    const replacedString = data.replaceAll("%%##%%##", '%%##').replaceAll("%%##", '\n');
    //console.log(newString)
    const updatedText = this.formattedStringArr(replacedString.split('\n'), function (part) {
      return [part, <div>{this.divider()}</div>];
    });
    updatedText.pop()
    return (
      <div>
        {updatedText}
      </div>
    )
  }
  indexData = event => {
    var title = [event.target.getAttribute('data-title')];
    var products = [event.target.getAttribute('data-products')];
    var docnumber = [event.target.getAttribute('data-docnumber')];
    var docversion = [event.target.getAttribute('data-version')];
    var contentsource = [event.target.getAttribute('data-contentsource')];
    var docID = [event.target.getAttribute('data-docid')];
    var docType = [event.target.getAttribute('data-doctype')];
    var docUrl = [event.target.getAttribute('data-docurl')]
    var doclastModified = [event.target.getAttribute('data-doclastmodified')]
    var orderedBy = [event.target.getAttribute('data-orderedby')]
    var orderedFor = [event.target.getAttribute('data-orderedfor')]
    const ts = new trackingService();
    ts.indexTrackingData(localStorage.getItem('userdisplayName'), localStorage.getItem('wwid'), localStorage.getItem('username'), localStorage.getItem('function'), localStorage.getItem('region'), localStorage.getItem('userproducts'), localStorage.getItem('doctypepref'), localStorage.getItem('sid'), localStorage.getItem('deviceType'), localStorage.getItem('deviceOS'), localStorage.getItem('browserName'), localStorage.getItem('browserVersion'), localStorage.getItem('jnjDepartment'), localStorage.getItem('companyname'), 'View OR Download Document', 'Direct', window.location.href, this.state.searchKeyword, this.state.appliedFilters, title, docversion, docnumber, docID, docUrl, products, docType, 'View Document', '', '', contentsource, this.props.pageNumber, this.props.pageSize, doclastModified, orderedBy, orderedFor);
  }
  indexPubMedData = event => {
    var title = [event.target.getAttribute('data-title')];
    var docUrl = [event.target.getAttribute('data-docurl')]
    const ts = new trackingService();
    ts.indexTrackingData(localStorage.getItem('userdisplayName'), localStorage.getItem('wwid'), localStorage.getItem('username'), localStorage.getItem('function'), localStorage.getItem('region'), localStorage.getItem('userproducts'), localStorage.getItem('doctypepref'), localStorage.getItem('sid'), localStorage.getItem('deviceType'), localStorage.getItem('deviceOS'), localStorage.getItem('browserName'), localStorage.getItem('browserVersion'), localStorage.getItem('jnjDepartment'), localStorage.getItem('companyname'), 'View OR Download PubMed Document', 'Direct', window.location.href, this.state.searchKeyword, this.state.appliedFilters, title, '', '', '', docUrl, '', '', 'View PubMed Document', '', '', 'PubMed', this.props.pageNumber, this.props.pageSize, '');
  }
  handleProtocolID = (protocolIDs) => {
    let ids = GenerateArrayStrings(protocolIDs)
    let url = window.location.origin + `/results?query=&q=All%20Fields&filters=&f1=protocolIDs&fval1=${ids}&fcount=1`;
    OpenWindow(url)
  }
  handlePubMedID = (pmID) => {
    let url = `https://pubmed.ncbi.nlm.nih.gov/${pmID}/?otool=pajanslib`;
    OpenWindow(url)
  }
  handleNCTID = (nctID) => {
    let url = `https://clinicaltrials.gov/ct2/show/${nctID}`;
    OpenWindow(url)
  }
  extractNCTId = (protocolIdsArr = []) => {
    var pidNCTArray = [];
    var pidStream = "";
    var nctStream = "";
    let nctId = protocolIdsArr?.filter(elm => elm.startsWith('NCT'))
    let pIds = protocolIdsArr?.filter(elm => !elm.startsWith('NCT'))
    if (pIds.length > 0) {
      pidStream = pIds.toString().split(',').join(';');
    }
    if (nctId.length > 0) {
      nctStream = nctId.toString().split(',').join(';');
    }
    pidNCTArray.push(pidStream)
    pidNCTArray.push(nctStream)
    return pidNCTArray;
  }
  renderNCThyperas = (nctIDs) => {
    if (nctIDs.length > 0) {
      return (
        nctIDs.map((item, index) => {
          if (index === nctIDs.length - 1) {
            return (
              <a href="javascript:void(0)" title="Click this field to view the full record on ClinicalTrials.gov web site" onClick={e => this.handleNCTID(item)} key={index}>{item}</a>
            )
          }
          else {
            return (
              <a href="javascript:void(0)" title="Click this field to view the full record on ClinicalTrials.gov web site" onClick={e => this.handleNCTID(item)} key={index}>{item}; </a>
            )
          }
          //return null;
        })
      )
    }
  }
  generateDocumentTeaser = (teaserData) => {
    let str = ''
    if (teaserData.length > 0) {
      teaserData.map((item, index) => {
        str += item + "..."
      })
    }
    //console.log(str)
    //console.log(this.convertToHtml(str))
    return str;
  }
  convertToHtml = (item) => {
    return (<div dangerouslySetInnerHTML={{ __html: item }}></div>)
  }
  handleToggleSelect = (collapseStatus) => {
    //console.log(collapseStatus)
    this.setState({
      // collapsed: !this.state.collapsed
      collapsed: collapseStatus
    })
  }

  formattedStringArr = (array, fn) => {
    var result = [];
    for (var i = 0; i < array.length; i++) {
      var mapping = fn(array[i]);
      result = result.concat(mapping);
    }
    return result;
  }
  divider = () => {
    return (
      <p></p>
    )
  }
  textFormatter = (data) => {
    const replacedString = data.replaceAll("%%##%%##", '%%##').replaceAll("%%##", '\n');
    let _this = this;
    const updatedText = this.formattedStringArr(replacedString.split('\n'), function (part) {
      return [part, <div>{_this.divider()}</div>];
    });
    updatedText.pop()
    return (
      <div>
        {updatedText}
      </div>
    )
  }
  handleOpenWindow = (pubMedId) => {
    let url = `https://www.rightfind.com/vlib/order/orderform.aspx?ClientId=60&qlu=${pubMedId}`
    OpenWindow(url)
  }
  textGreenlightVersionFormatter = (greenlightVersionDocID) => {
    let docs = [];
    let greenlightVersionDocs = greenlightVersionDocID.split('$$');
    greenlightVersionDocs.map(x => {
      let greenlightVersion = x.split('@@');
      let _doc = { version: greenlightVersion[0], objectId: greenlightVersion[1], objectName: "", greenlightApprovedDate: "", greenlightApprovedDateStr: "", documentApprovedDate: "" }
      if (greenlightVersion.length > 2) {
        _doc.objectName = greenlightVersion[2]
      }
      if (greenlightVersion.length > 3 && greenlightVersion[3]) {
        _doc.greenlightApprovedDate = moment(greenlightVersion[3]).format("MM/DD/YYYY")
      }
      if (greenlightVersion.length > 4 && greenlightVersion[4] && greenlightVersion[4] !== "null") {

        _doc.greenlightApprovedDateStr = moment(greenlightVersion[4]).format("DD-MMM-YYYY")
      }
      if (greenlightVersion.length > 5 && greenlightVersion[5] && greenlightVersion[5] !== "null") {

        _doc.documentApprovedDate = moment(greenlightVersion[5]).format("DD-MMM-YYYY")
      }
      docs.push(_doc);
    })
    // docs = docs.sort((a, b) => parseFloat(b.version) - parseFloat(a.version));
    //docs = docs.sort((a, b) => moment(b.greenlightApprovedDateStr) - moment(a.greenlightApprovedDateStr));
    //docs = docs.sort((a, b) => moment(b.documentApprovedDate) - moment(a.documentApprovedDate));
    docs = docs.sort((a, b) => {
      // Primary sort: by firstName
      try {
        if (moment(b.documentApprovedDate) < moment(a.documentApprovedDate)) {
          return -1;
        }
        if (moment(b.documentApprovedDate) > moment(a.documentApprovedDate)) {
          return 1;
        }

        // Secondary sort: if firstNames are equal, sort by lastName
        if (moment(b.greenlightApprovedDateStr) < moment(a.greenlightApprovedDateStr)) {
          return -1;
        }
        if (moment(b.greenlightApprovedDateStr) > moment(a.greenlightApprovedDateStr)) {
          return 1;
        }
      } catch (error) {
        console.log("error", error)
      }
      return 0;
    });
    return (
      <div className="greenlight-table-wrapper">
        <table cellPadding={5} cellSpacing={0} border={1} >
          <thead>
            <tr>
              {/* <th>System Version Number</th> */}
              <th>Object Name</th>
              <th>Greenlight Approved Date
                <br />
                <span className="gen-ai-greenlight-version__approved-label-subtitle">(For Safety Reporting Only)</span>
              </th>
            </tr>
          </thead>
          <tbody>
            {docs.map(x => {
              return (<tr>
                {/* <td><a href={`${window.location.origin}/DocURL?ID=${x.objectId}&ref=pdf&cs=RIMdocs&orderedBy=&orderedFor=&greenLight=true`} target="_blank" >{x.version}</a></td> */}
                <td><a href={`${window.location.origin}/DocURL?ID=${x.objectId}&ref=pdf&cs=RIMdocs&orderedBy=&orderedFor=&fileType=pdf&fileName=${x.objectName}&greenLight=true`} target="_blank" >{x.objectName}</a></td>
                {/* <td>{x.greenlightApprovedDate}</td> */}
                <td>{x.greenlightApprovedDateStr}</td>
              </tr>)
            })}
          </tbody>
        </table>
      </div>
    )
  }
  onlyUnique(value, index, array) {
    return array.indexOf(value) === index;
  }
  titleCase(str) {
    str = str.toLowerCase().split(' ');
    for (var i = 0; i < str.length; i++) {
      str[i] = str[i].charAt(0).toUpperCase() + str[i].slice(1);
    }
    return str.join(' ');
  }
  urlGenerator(item) {
    let url = ``;
    let { orderedBy, orderedFor } = item;
    if (!orderedBy) orderedBy = '';
    if (!orderedFor) orderedFor = '';
    if (item.domain === 'RIMdocs' || item.domain === 'RIMdocs_LL' || item.domain === 'CTGov') {
      url = `/DocURL?ID=${item.docID}&cs=${item.domain}&fileType=${item.fileExtension}&fileName=${encodeURIComponent(item.docTitle)}&orderedBy=${orderedBy}&orderedFor=${orderedFor}`
      // url = `/DocURL?ID=${item.docTitle}&cs=${item.domain}`
    }
    else if (item.domain === 'SKM' || item.domain === "MIAs") {
      url = `/DocURL?ID=${item.docID}&cs=${item.domain}&connID=${item.connID}&csID=${item.csID}&fileType=${item.fileExtension}&fileName=${encodeURIComponent(item.docTitle)}&orderedBy=${orderedBy}&orderedFor=${orderedFor}`
    }
    else {
      url = `/DocURL?ID=${item.docID}&cs=${item.domain}&connID=${item.connID}&csID=${item.csID}&fileType=${item.fileExtension}&docVer=${item.majorVersionNumber}&fileName=${encodeURIComponent(item.docTitle)}&orderedBy=${orderedBy}&orderedFor=${orderedFor}`
      if (item.a_status === "Approved Needs Review" || item.status === "Approved Needs Review") {
        url = url + `&docState=anr`
      }
    }
    if (item.enclosureDocID) {
      url += `&enclosureID=${item.enclosureDocID}`
    }
    url += `&ref=pdf`
    return url
  }
  render() {
    let { showFilters } = this.state;
    var approvedDate;
    if (this.state.item.approvedDate) {
      approvedDate = moment(this.state.item.approvedDate).format("D-MMM-YYYY");
    }
    var modifiedDate;
    if (this.state.item.modifiedDate) {
      modifiedDate = moment(this.state.item.modifiedDate).format("D-MMM-YYYY");
    } else {
      modifiedDate = moment(this.state.item.lastUpdated).format("D-MMM-YYYY");
    }
    let ctNames = [];
    if (this.state.item.ctNames || this.state.item.clinicalTrialName) {
      if (this.state.item.ctNames && this.state.item.ctNames.length > 0) {
        ctNames = this.state.item.ctNames;
      } else {
        if (
          this.state.item.clinicalTrialName &&
          this.state.item.clinicalTrialName.length > 0
        ) {
          if (
            this.state.item.clinicalTrialName.length > 0 &&
            Array.isArray(this.state.item.clinicalTrialName)
          ) {
            ctNames = this.state.item.clinicalTrialName;
          } else {
            ctNames = [this.state.item.clinicalTrialName];
          }
        }
      }
    }
    //console.log(this.props.item.domain);
    if (window.location.pathname !== "/pubMedResults" && window.location.pathname !== "/viewPubMedReadingList") {
      //#region for iMS render
      if (this.state.item) {
        let { orderedBy, orderedFor } = this.state.item;
        if (!orderedBy) orderedBy = '';
        if (!orderedFor) orderedFor = '';
        if (this.state.item.domain === "SKM") {
          //let userid=localStorage.getItem('username').toLowerCase().replace(/"/g,'').split('@')[0]
          let url = `/api/dcs-spo/download?connID=${this.state.item.connID}&csID=${this.state.item.csID}&docID=${this.state.item.docID}&fileType=${this.state.item.fileExtension}&fileName=${encodeURIComponent(this.state.item.docTitle.toString().replace(/\n/g, " "))}`;
          // let downloadurl = `/api/dcs-spo/download?connID=${this.state.item.connID}%26csID=${this.state.item.csID}%26docID=${this.state.item.docID}%26fileType=${this.state.item.fileExtension}%26fileName=${this.state.item.docTitle}`;
          let downloadurl = `/api/dcs-spo/download?connID=${this.state.item.connID}&csID=${this.state.item.csID}&docID=${this.state.item.docID}&fileType=${this.state.item.fileExtension}&fileName=${this.state.item.docTitle}`;
          downloadurl = downloadurl.replace(/ /g, "%20");
          let mailUrl = window.location.origin + downloadurl;
          if (this.state.item.fileExtension === "aspx") {
            url = this.state.item.linkURL ? this.state.item.linkURL : this.state.item.spoWebURL;
            mailUrl = this.state.item.linkURL ? this.state.item.linkURL : this.state.item.spoWebURL;
            if (mailUrl) {
              mailUrl = mailUrl.replace(/ /g, "%20");
            } else {
              mailUrl = "";
            }
          }
          let encodeMailUrl = encodeURIComponent(mailUrl.trim());
          let mailbody = `Title: ${encodeURIComponent(this.state.item.docTitle)}%0D%0DUrl: ${encodeMailUrl}%0D%0DFor access to iMedical Search, please contact iMedical Search Team `;
          let mailref = `mailto:${this.state.item.contactEmail}?Subject=iMedical Search Document: ${encodeURIComponent(this.state.item.docTitle)}&body=${mailbody}`;
          if (this.state.item.fileExtension === "aspx") {
            var downloadURL = this.state.item.linkURL ? this.state.item.linkURL : this.state.item.spoWebURL;
            //this.documentUrl(`/api/dcs-spo/download?connID=${this.state.item.connID}&csID=${this.state.item.csID}&docID=${this.state.item.docID}&fileType=${this.state.item.fileExtension}&fileName=${this.state.item.docTitle}&spoWebURL=${encodeURIComponent(downloadURL)}`);
          } else {
            //this.documentUrl(url);
          }
          return (
            <div className="doc-card-inner">
              <div className="doc-row header-row">
                {/* <div className="left-icons">
                  <div className="checkbox-outline" data-size="M" data-state="Enabled">
                    <input type="checkbox" value={this.state.item.docTitle} key={this.state.item.docID + Math.random()} onChange={() => this.props.handelCitationSelect(this.state.documentIndex, this.props.item, this.props.itemTeaser)} checked={this.props.isChecked} style={{ cursor: "pointer", width: "14px", height: "14px" }}  />
                  </div>
                  <div className="small-square">
                    <img src={this.state.collapsed ? JJ_Icon_expandIcon : JJ_Icon_collapseIcon} alt="expand/collapse-icon" width={14} height={14} onClick={this.props.handleExpandCollapse} style={{ marginTop: this.props.customWidth < 600 ? "35%" : null, cursor: "pointer" }} />
                  </div>
                </div> */}

                <div className="doc-title">
                  {this.state.item.fileExtension === "aspx" ?
                    <a
                      id="docdata"
                      to={{ pathname: url }}
                      target="_blank"
                      onClick={this.indexData}
                      data-title={this.state.item.docTitle}
                      data-products={this.state.item.tempJNJDrugs}
                      data-docnumber={this.state.item.domain}
                      data-contentsource={this.state.item.domain}
                      data-docid={this.state.item.searchID}
                      data-doctype={this.state.item.docType}
                      data-docurl={url}
                      data-doclastmodified={this.state.item.createdDate}
                      data-orderedby={orderedBy}
                      data-orderedfor={orderedFor}
                    >
                      {this.state.documentIndex}.{" "}{this.state.item.docTitle}
                    </a>
                    :
                    <a
                      id="docdata"
                      href={window.location.origin + this.urlGenerator(this.state.item)}
                      target="_blank"
                      onClick={this.indexData}
                      data-title={this.state.item.docTitle}
                      data-products={this.state.item.tempJNJDrugs}
                      data-docnumber={this.state.item.domain}
                      data-contentsource={this.state.item.domain}
                      data-docid={this.state.item.searchID}
                      data-doctype={this.state.item.docType}
                      data-docurl={this.urlGenerator(this.state.item)}
                      data-doclastmodified={this.state.item.createdDate}
                      data-orderedby={orderedBy}
                      data-orderedfor={orderedFor}
                    >
                      {this.state.documentIndex}.{" "}{this.state.item.docTitle}
                    </a>
                  }
                </div>

              </div>
              {!this.state.collapsed ? (<>
                {/* Metadata two-column grid */}
                <div className="doc-row meta-row">
                  <div className="meta-column">
                    {this.state.item.authors !== undefined &&
                      this.state.item.authors.length > 0 && (
                        <div className="meta-item">
                          <span className="meta-label">Authors: </span>
                          <span className="meta-value">{getVarType(this.state.item.authors) !== "Array"
                            ? this.state.item.authors
                            : GenerateArrayStrings(this.state.item.authors)}</span>
                        </div>)}
                    {this.state.item.owner && (
                      <div className="meta-item">
                        <span className="meta-label">
                          Owner: </span>
                        <span className="meta-value"><a href={mailref}>{this.state.item.owner}</a></span>
                      </div>
                    )}
                    {this.state.item.product !== undefined &&
                      this.state.item.product.length > 0 && (
                        <div className="meta-item">
                          <span className="meta-label">Product: </span>
                          <span className="meta-value">{GenerateArrayStrings(this.state.item.product)}</span>
                        </div>
                      )}
                    {this.state.item.usageGuidelines && (
                      <div className="meta-item">
                        <span className="meta-label">Usage Guidelines: </span>
                        <span className="meta-value">{this.state.item.usageGuidelines}</span>
                      </div>
                    )}
                    {this.state.item.audience && (
                      <div className="meta-item">
                        <span className="meta-label">Audience: </span>
                        <span className="meta-value">{this.state.item.audience}</span>
                      </div>
                    )}
                    {this.state.item.congressName !== undefined &&
                      this.state.item.congressName.length > 0 && (
                        <div className="meta-item">
                          <span className="meta-label">Congress Name: </span>
                          <span className="meta-value">{GenerateArrayStrings(
                            this.state.item.congressName
                          )}</span>
                        </div>
                      )}
                  </div>
                  <div className="meta-column">
                    {this.state.item.maintValidUntil && (
                      <div className="meta-item">
                        <span className="meta-label">Valid Until: </span>
                        <span className="meta-value">{moment(this.state.item.maintValidUntil).format("D-MMM-YYYY")}{" "}</span>
                      </div>
                    )}
                    {this.state.item.assetType && (
                      <div className="meta-item">
                        <span className="meta-label">Asset Type: </span>
                        <span className="meta-value">{this.state.item.assetType}</span>
                      </div>
                    )}
                    {this.state.item.description && (
                      <div className="meta-item">
                        <span className="meta-label">Description: </span>
                        <span className="meta-value" style={{ wordWrap: "break-word" }}>{this.state.item.description}</span>
                      </div>
                    )}
                    {this.state.item.languages !== undefined &&
                      this.state.item.languages.length > 0 ? (
                      <div className="meta-item">
                        <span className="meta-label">Language: </span>
                        <span className="meta-value">{this.state.item.languages}</span>
                      </div>
                    ) : (
                      <div className="meta-item">
                        <span className="meta-label">Language: </span>
                        <span className="meta-value">English</span>
                      </div>
                    )}
                    {this.state.item.csName && (
                      <div className="meta-item">
                        <span className="meta-label">Content Source: </span>
                        <span className="meta-value">NAVIGATOR</span>
                      </div>
                    )}
                    {this.state.item.status && (
                      <div className="meta-item">
                        <span className="meta-label">Status: </span>
                        <span className="meta-value">{this.state.item.status}</span>
                      </div>
                    )}

                  </div>
                </div>
              </>) : null}
            </div>
          );
        }
        else if (this.state.item.domain === "RIMdocs") {
          //let userid=localStorage.getItem('username').toLowerCase().replace(/"/g,'').split('@')[0]
          let url = `/api/download/RIMdocs?strID=${this.state.item.docID}`;
          // let url = `/api/download/RIMdocs?strID=${this.state.item.docTitle}`
          //this.documentUrl(url);
          return (
            <div className="doc-card-inner">
              <div className="doc-row header-row">
                {/* <div className="left-icons">
                  <div className="checkbox-outline" data-size="M" data-state="Enabled">
                    <input type="checkbox" value={this.state.item.docTitle} key={this.state.item.docID + Math.random()} onChange={() => this.props.handelCitationSelect(this.state.documentIndex, this.props.item, this.props.itemTeaser)} checked={this.props.isChecked} style={{ cursor: "pointer", width: "14px", height: "14px" }}  />
                  </div>
                  <div className="small-square">
                    <img src={this.state.collapsed ? JJ_Icon_expandIcon : JJ_Icon_collapseIcon} alt="expand/collapse-icon" width={14} height={14} onClick={this.props.handleExpandCollapse} style={{ marginTop: this.props.customWidth < 600 ? "35%" : null, cursor: "pointer" }} />
                  </div>
                </div> */}
                <div className="doc-title">
                  <a
                    id="docdata"
                    href={window.location.origin + this.urlGenerator(this.state.item)}
                    target="_blank"
                    onClick={this.indexData}
                    data-title={this.state.item.docTitle}
                    data-products={this.state.item.tempJNJDrugs}
                    data-docnumber={this.state.item.jj_number}
                    data-version={this.state.item.r_version_label}
                    data-contentsource={this.state.item.domain}
                    data-docid={this.state.item.searchID}
                    data-doctype={this.state.item.docType}
                    data-docurl={this.urlGenerator(this.state.item)}
                    data-doclastmodified={this.state.item.createdDate}
                    data-orderedby={orderedBy}
                    data-orderedfor={orderedFor}
                  >
                    {this.state.documentIndex}.{" "}{this.state.item.docTitle}
                  </a>
                </div>
              </div>
              {!this.state.collapsed ? (<>
                {/* Description */}
                {this.props.itemTeaser !== undefined &&
                  this.props.itemTeaser.length > 0 && (
                    <div className="doc-row description-row">
                      <div className="description">
                        {this.convertToHtml(
                          this.generateDocumentTeaser(this.props.itemTeaser)
                        )}
                      </div>
                    </div>
                  )}

                {/* Metadata two-column grid */}
                <div className="doc-row meta-row meta-data-row-bgcolor">
                  <div className="meta-column">
                    {this.state.item.object_name && (
                      <div className="meta-item">
                        <span className="meta-label">File Name: </span>
                        <span className="meta-value" style={{ wordWrap: "break-word" }}>{this.state.item.object_name}</span>
                      </div>
                    )}
                    {this.state.item.product_code !== undefined &&
                      this.props.item.product_code.length > 0 && (
                        <div className="meta-item">
                          <span className="meta-label">Primary Compound ID: </span>
                          <span className="meta-value">{this.state.item.product_code}</span>
                        </div>
                      )}
                    {(this.state.item.product_generic_name !== undefined &&
                      this.state.item.product_generic_name.length > 0 &&
                      Array.isArray(this.state.item.product_generic_name)
                    ) && (
                        <div className="meta-item">
                          <span className="meta-label">Generic Name: </span>
                          <span className="meta-value" style={{ wordWrap: "break-word" }}>{GenerateArrayStrings(uniq(this.state.item.product_generic_name.filter(x => x)))}</span>
                        </div>
                      )}
                    {(this.state.item.product_generic_name !== undefined &&
                      this.state.item.product_generic_name.length > 0 &&
                      !Array.isArray(this.state.item.product_generic_name)
                    ) && (
                        <div className="meta-item">
                          <span className="meta-label">Generic Name:</span>
                          <span className="meta-value" style={{ wordWrap: "break-word" }}>{this.state.item.product_generic_name}</span>
                        </div>
                      )}
                    {(this.state.item.product_generic_name_alias !== undefined &&
                      this.state.item.product_generic_name_alias.length > 0) && (
                        <div className="meta-item">
                          <span className="meta-label">Generic Name (Aliases): </span>
                          <span className="meta-value" style={{ wordWrap: "break-word" }}>{this.state.item.product_generic_name_alias}</span>
                        </div>
                      )}
                    {this.state.item.jj_component_name && (
                      <div className="meta-item">
                        <span className="meta-label">Component Name: </span>
                        <span className="meta-value">{this.state.item.jj_component_name}</span>
                      </div>
                    )}

                    {(this.state.item.protocolIDs !== undefined &&
                      this.state.item.protocolIDs.length > 0) ? (
                      <div className="meta-item">
                        <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 32 32"
                          width="18"
                          title="Click this field to retrieve all evidence from iMS assigned these Protocol IDs/Numbers. This will appear in a new browser tab."
                          className="citation-info-icon-wrapper"
                          alt="Click this field to retrieve all evidence from iMS assigned these Protocol IDs/Numbers. This will appear in a new browser tab.">
                          <path d="M16 2C8.27 2 2 8.27 2 16s6.27 14 14 14 14-6.27 14-14S23.73 2 16 2zm0 26C9.38 28 4 22.62 4 16S9.38 4 16 4s12 5.39 12 12-5.38 12-12 12zm.03-15.41a1.83 1.83 0 1 0-1.83-1.83 1.83 1.83 0 0 0 1.83 1.83zm1.1 8.86c-1.14 0-1.13-.79-.83-1.95l.9-3.5.52-2h-5.71v2h2.08l-1 3.88c-.38 1.34-.09 3.26 2.63 3.26 1.75 0 2.66-.97 3.14-1.92-.25-.19-.19-.15-.44-.33-.33.31-.76.56-1.29.56z" style={{ fill: "#eb1600" }} /></svg>
                        <span className="meta-label">Protocol No: </span>
                        <span className="meta-value"><a
                          href="javascript:void(0)"
                          title="Click this field to retrieve all evidence from iMS assigned these Protocol IDs/Numbers. This will appear in a new browser tab"
                          onClick={(evt) =>
                            this.handleProtocolID(
                              this.state.item.protocolIDs
                            )
                          }
                        >
                          {GenerateArrayStrings(
                            ctNames.concat(this.state.item.protocolIDs)
                          )}
                        </a>
                        </span>
                      </div>
                    ) : (
                      ctNames &&
                      ctNames.length > 0 && (<div className="meta-item">
                        <span className="meta-label">Protocol No: </span>
                        <span className="meta-value">{GenerateArrayStrings(ctNames)}</span>
                      </div>)
                    )}
                    {this.state.item.protocolIDAliases !== undefined &&
                      this.state.item.protocolIDAliases.length > 0 && (
                        <div className="meta-item">
                          <span className="meta-label">Protocol No (Aliases): </span>
                          <span className="meta-value" style={{ wordWrap: "break-word" }}>
                            <a href="javascript:void(0)">
                              {this.state.item.protocolIDAliases}
                            </a>
                          </span>
                        </div>
                      )}
                    {this.state.item.jj_number && (
                      <div className="meta-item">
                        <span className="meta-label">Document No: </span>
                        <span className="meta-value">{this.state.item.jj_number}</span>
                      </div>
                    )}
                    {this.state.item.phaseOfStudy !== undefined &&
                      this.state.item.phaseOfStudy > 0 && (
                        <div className="meta-item">
                          <span className="meta-label">Phase of Study: </span>
                          <span className="meta-value">{this.state.item.phaseOfStudy}</span>
                        </div>
                      )}
                    {this.state.item.pageCount && (
                      <div className="meta-item">
                        <span className="meta-label">Page Count: </span>
                        <span className="meta-value">{this.state.item.pageCount}</span>
                      </div>
                    )}
                  </div>
                  <div className="meta-column">
                    {approvedDate && (
                      <div className="meta-item">
                        <span className="meta-label">Approved Date: </span>
                        <span className="meta-value">{approvedDate}</span>
                      </div>
                    )}
                    {modifiedDate &&
                      this.state.item.modifiedDate !== undefined &&
                      this.state.item.modifiedDate.length > 0 && (
                        <div className="meta-item">
                          <span className="meta-label">Modified Date: </span>
                          <span className="meta-value">{modifiedDate}</span>
                        </div>
                      )}
                    {this.state.item.r_version_label && (
                      <div className="meta-item">
                        <span className="meta-label">System Version Number: </span>
                        <span className="meta-value">{this.state.item.r_version_label}</span>
                      </div>
                    )}
                    {this.state.item.docType !== undefined &&
                      this.state.item.docType.length > 0 && (
                        <div className="meta-item">
                          <span className="meta-label">Document Type: </span>
                          <span className="meta-value">{this.state.item.docType}</span>
                        </div>
                      )}
                    {this.state.item.jj_artifact_short_name && (
                      <div className="meta-item">
                        <span className="meta-label">Artifact Short Name: </span>
                        <span className="meta-value">{this.state.item.jj_artifact_short_name}</span>
                      </div>
                    )}
                    {this.state.item.jj_reason_for_revision && (
                      <div className="meta-item">
                        <span className="meta-label">Reason For Revision: </span>
                        <span className="meta-value">{this.state.item.jj_reason_for_revision}</span>
                      </div>
                    )}
                    {this.state.item.languages ? (
                      <div className="meta-item">
                        <span className="meta-label">Language: </span>
                        <span className="meta-value">{this.state.item.languages}</span>
                      </div>
                    ) : (
                      <div className="meta-item">
                        <span className="meta-label">Language: </span>
                        <span className="meta-value">English</span>
                      </div>
                    )}
                    {this.state.item.domain && (
                      <div className="meta-item">
                        <span className="meta-label">Content Source: </span>
                        <span className="meta-value">{this.state.item.domain}</span>
                      </div>
                    )}
                    {this.state.item.a_status && (
                      <div className="meta-item">
                        <span className="meta-label">Status: </span>
                        <span className="meta-value">{this.state.item.a_status}</span>
                      </div>
                    )}
                    {this.state.item.docType && this.state.item.docType.includes("Investigator's Brochures") && (
                      <>{this.state.item.isCurrentVerGreenlight ? (
                        <div className="meta-item">
                          <span className="meta-label">Current Greenlight Status: </span>
                          <span className="meta-value">Yes</span>
                        </div>) : (<div className="meta-item">
                          <span className="meta-label">Current Greenlight Status: </span>
                          <span className="meta-value">No</span>
                        </div>)}
                      </>)}

                  </div>
                </div>
                <div className="doc-row meta-row">
                  {this.state.item.greenlightVersionDocID && (
                    <div className="PHM-MetaDataProperty">
                      <div style={{ display: "block" }}>
                        <GenAIGreenlightVersion
                          greenlightVersionDocID={this.state.item.greenlightVersionDocID} />
                      </div>
                    </div>
                  )}
                </div>
              </>) : null}
            </div>
          );

        }
        else if (this.state.item.domain === "RIMdocs_LL") {
          //let userid=localStorage.getItem('username').toLowerCase().replace(/"/g,'').split('@')[0]
          let url = `/api/download/RIMdocs?strID=${this.state.item.docID}`;
          // let url = `/api/download/RIMdocs?strID=${this.state.item.docTitle}`
          // this.documentUrl(url);
          return (
            <div className="doc-card-inner">
              <div className="doc-row header-row">
                {/* <div className="left-icons">
                  <div className="checkbox-outline" data-size="M" data-state="Enabled">
                    <input type="checkbox" value={this.state.item.docTitle} key={this.state.item.docID + Math.random()} onChange={() => this.props.handelCitationSelect(this.state.documentIndex, this.props.item, this.props.itemTeaser)} checked={this.props.isChecked} style={{ cursor: "pointer", width: "14px", height: "14px" }}  />
                  </div>
                  <div className="small-square">
                    <img src={this.state.collapsed ? JJ_Icon_expandIcon : JJ_Icon_collapseIcon} alt="expand/collapse-icon" width={14} height={14} onClick={this.props.handleExpandCollapse} style={{ marginTop: this.props.customWidth < 600 ? "35%" : null, cursor: "pointer" }} />
                  </div>
                </div> */}
                <div className="doc-title">
                  <a
                    id="docdata"
                    href={window.location.origin + this.urlGenerator(this.state.item)}
                    target="_blank"
                    onClick={this.indexData}
                    data-title={this.state.item.docTitle}
                    data-products={this.state.item.tempJNJDrugs}
                    data-docnumber={this.state.item.jj_number}
                    data-version={this.state.item.r_version_label}
                    data-contentsource={this.state.item.domain}
                    data-docid={this.state.item.searchID}
                    data-doctype={this.state.item.docType}
                    data-docurl={this.urlGenerator(this.state.item)}
                    data-doclastmodified={this.state.item.createdDate}
                    data-orderedby={orderedBy}
                    data-orderedfor={orderedFor}
                  >
                    {this.state.documentIndex}.{" "}{this.state.item.docTitle}
                  </a>
                </div>
              </div>
              {!this.state.collapsed ? (<>
                {/* Description */}
                {this.props.itemTeaser !== undefined &&
                  this.props.itemTeaser.length > 0 && (
                    <div className="doc-row description-row">
                      <div className="description">
                        {this.convertToHtml(
                          this.generateDocumentTeaser(this.props.itemTeaser)
                        )}
                      </div>
                    </div>
                  )}

                {/* Metadata two-column grid */}
                <div className="doc-row meta-row meta-data-row-bgcolor">
                  <div className="meta-column">
                    {this.state.item.object_name && (
                      <div className="meta-item">
                        <span className="meta-label">File Name: </span>
                        <span className="meta-value">{this.state.item.object_name}</span>
                      </div>
                    )}
                    {this.state.item.product_code !== undefined &&
                      this.props.item.product_code.length > 0 && (
                        <div className="meta-item">
                          <span className="meta-label">Primary Compound ID: </span>
                          <span className="meta-value">{this.state.item.product_code}</span>
                        </div>
                      )}
                    {(this.state.item.product_generic_name !== undefined &&
                      this.state.item.product_generic_name.length > 0 &&
                      Array.isArray(this.state.item.product_generic_name)
                    ) && (
                        <div className="meta-item">
                          <span className="meta-label">Generic Name: </span>
                          <span className="meta-value">{GenerateArrayStrings(uniq(this.state.item.product_generic_name.filter(x => x)))}</span>
                        </div>
                      )}
                    {(this.state.item.product_generic_name !== undefined &&
                      this.state.item.product_generic_name.length > 0 &&
                      !Array.isArray(this.state.item.product_generic_name)
                    ) && (
                        <div className="meta-item">
                          <span className="meta-label">Generic Name:</span>
                          <span className="meta-value">{this.state.item.product_generic_name}</span>
                        </div>
                      )}
                    {(this.state.item.product_generic_name_alias !== undefined &&
                      this.state.item.product_generic_name_alias.length > 0) && (
                        <div className="meta-item">
                          <span className="meta-label">Generic Name (Aliases): </span>
                          <span className="meta-value">{this.state.item.product_generic_name_alias}</span>
                        </div>
                      )}
                    {(this.state.item.protocolIDs !== undefined &&
                      this.state.item.protocolIDs.length > 0) ? (
                      <div className="meta-item">
                        <span className="meta-label">Protocol No: </span>
                        <span className="meta-value"><a
                          href="javascript:void(0)"
                          title="Click this field to retrieve all evidence from iMS assigned these Protocol IDs/Numbers. This will appear in a new browser tab"
                          onClick={(evt) =>
                            this.handleProtocolID(
                              this.state.item.protocolIDs
                            )
                          }
                        >
                          {GenerateArrayStrings(
                            ctNames.concat(this.state.item.protocolIDs)
                          )}
                        </a>
                        </span>
                      </div>
                    ) : (
                      ctNames &&
                      ctNames.length > 0 && (<div className="meta-item">
                        <span className="meta-label">Protocol No: </span>
                        <span className="meta-value">{GenerateArrayStrings(ctNames)}</span>
                      </div>)
                    )}
                    {this.state.item.protocolIDAliases !== undefined &&
                      this.state.item.protocolIDAliases.length > 0 && (
                        <div className="meta-item">
                          <span className="meta-label">Protocol No (Aliases): </span>
                          <span className="meta-value" style={{ wordWrap: "break-word" }}>
                            <a href="javascript:void(0)">
                              {this.state.item.protocolIDAliases}
                            </a>
                          </span>
                        </div>
                      )}
                    {this.state.item.jj_number && (
                      <div className="meta-item">
                        <span className="meta-label">Document No: </span>
                        <span className="meta-value">{this.state.item.jj_number}</span>
                      </div>
                    )}
                    {this.state.item.phaseOfStudy !== undefined &&
                      this.state.item.phaseOfStudy > 0 && (
                        <div className="meta-item">
                          <span className="meta-label">Phase of Study: </span>
                          <span className="meta-value">{this.state.item.phaseOfStudy}</span>
                        </div>
                      )}
                    {this.state.item.r_version_label && (
                      <div className="meta-item">
                        <span className="meta-label">System Version Number: </span>
                        <span className="meta-value">{this.state.item.r_version_label}</span>
                      </div>
                    )}

                  </div>
                  <div className="meta-column">
                    {this.state.item.docType !== undefined &&
                      this.state.item.docType.length > 0 && (
                        <div className="meta-item">
                          <span className="meta-label">Document Type: </span>
                          <span className="meta-value">{this.state.item.docType}</span>
                        </div>
                      )}
                    {this.state.item.jj_region_country !== undefined && (
                      <div className="meta-item">
                        <span className="meta-label">Country: </span>
                        <span className="meta-value">{this.state.item.jj_region_country}</span>
                      </div>
                    )}

                    {this.state.item.languages ? (
                      <div className="meta-item">
                        <span className="meta-label">Language: </span>
                        <span className="meta-value">{this.state.item.languages}</span>
                      </div>
                    ) : (
                      <div className="meta-item">
                        <span className="meta-label">Language: </span>
                        <span className="meta-value">English</span>
                      </div>
                    )}
                    {this.state.item.jj_reason_for_revision && (
                      <div className="meta-item">
                        <span className="meta-label">Reason For Revision: </span>
                        <span className="meta-value">{this.state.item.jj_reason_for_revision}</span>
                      </div>
                    )}
                    {this.state.item.domain && (
                      <div className="meta-item">
                        <span className="meta-label">Content Source: </span>
                        <span className="meta-value">{this.state.item.domain}</span>
                      </div>
                    )}
                    {this.state.item.a_status && (
                      <div className="meta-item">
                        <span className="meta-label">Status: </span>
                        <span className="meta-value">{this.state.item.a_status}</span>
                      </div>
                    )}
                  </div>
                </div>

              </>) : null}
            </div>
          );
        } else if (this.state.item.domain === "MLR") {
          //let userid=localStorage.getItem('username').toLowerCase().replace(/"/g,'').split('@')[0]
          let extractedIds = [];
          if (this.state.item.protocolIDs) {
            extractedIds = this.extractNCTId(this.state.item.protocolIDs);
          }
          //console.log(extractedIds)
          let url;
          if (this.state.item.fileExtension !== "pdf") {
            url = `/api/dcs-vv/download?connID=${this.state.item.connID}&csID=${this.state.item.csID}&docID=${this.state.item.docID}&fileType=${this.state.item.fileExtension}&docVer=${this.state.item.majorVersionNumber}&fileName=${encodeURIComponent(this.state.item.docTitle.toString().replace(/\n/g, " "))}`;
          } else {
            url = `/api/dcs-vv/download?connID=${this.state.item.connID}&csID=${this.state.item.csID}&docID=${this.state.item.docID}&fileType=${this.state.item.fileExtension}&fileName=${encodeURIComponent(this.state.item.docTitle.toString().replace(/\n/g, " "))}`;
          }
          if (this.state.item.status === "Approved Needs Review") {
            url = url + `&docState=anr`;
          }
          //this.documentUrl(url);
          return (
            <div className="doc-card-inner">
              <div className="doc-row header-row">
                {/* <div className="left-icons">
                  <div className="checkbox-outline" data-size="M" data-state="Enabled">
                    <input type="checkbox" value={this.state.item.docTitle} key={this.state.item.docID + Math.random()} onChange={() => this.props.handelCitationSelect(this.state.documentIndex, this.props.item, this.props.itemTeaser)} checked={this.props.isChecked} style={{ cursor: "pointer", width: "14px", height: "14px" }}  />
                  </div>
                  <div className="small-square">
                    <img src={this.state.collapsed ? JJ_Icon_expandIcon : JJ_Icon_collapseIcon} alt="expand/collapse-icon" width={14} height={14} onClick={this.props.handleExpandCollapse} style={{ marginTop: this.props.customWidth < 600 ? "35%" : null, cursor: "pointer" }} />
                  </div>
                </div> */}
                <div className="doc-title">
                  <a
                    id="docdata"
                    href={window.location.origin + this.urlGenerator(this.state.item)}
                    target="_blank"
                    onClick={this.indexData}
                    data-title={this.state.item.docTitle}
                    data-products={this.state.item.tempJNJDrugs}
                    data-docnumber={this.state.item.documentNumber}
                    data-contentsource={this.state.item.domain}
                    data-docid={this.state.item.searchID}
                    data-doctype={this.state.item.docType}
                    data-docurl={this.urlGenerator(this.state.item)}
                    data-doclastmodified={this.state.item.createdDate}
                    data-orderedby={orderedBy}
                    data-orderedfor={orderedFor}
                  >
                    {this.state.documentIndex}.{" "}{this.state.item.docTitle}
                  </a>
                </div>
              </div>
              {!this.state.collapsed ? (<>
                {/* Description */}
                {this.props.itemTeaser !== undefined &&
                  this.props.itemTeaser.length > 0 && (
                    <div className="doc-row description-row">
                      <div className="description">
                        {this.convertToHtml(
                          this.generateDocumentTeaser(this.props.itemTeaser)
                        )}
                      </div>
                    </div>
                  )}

                {/* Metadata two-column grid */}
                <div className="doc-row meta-row meta-data-row-bgcolor">
                  <div className="meta-column">
                    {this.state.item.authors !== undefined &&
                      this.state.item.authors.length > 0 && (
                        <div className="meta-item">
                          <span className="meta-label">Authors: </span>
                          {/* <span className="meta-value">{getVarType(this.state.item.authors) !== "Array"
                                ? this.state.item.authors
                                : GenerateArrayStrings(this.state.item.authors)}</span> */}
                          <span className="meta-value" style={{ wordWrap: "break-word" }}>{getVarType(this.state.item.authors) !== "Array"
                            ? this.state.item.authors
                            : GenerateArrayStrings(this.state.item.authors)}</span>
                        </div>)}
                    {this.state.item.product !== undefined &&
                      this.state.item.product.length > 0 && (
                        <div className="meta-item">
                          <span className="meta-label">Products: </span>
                          <span className="meta-value">{GenerateArrayStrings(this.state.item.product)}</span>
                        </div>
                      )}
                    {this.state.item.year && (
                      <div className="meta-item">
                        <span className="meta-label">Date: </span>
                        <span className="meta-value">{this.state.item.year}</span>
                      </div>
                    )}
                    {this.state.item.congressName !== undefined &&
                      this.state.item.congressName.length > 0 && (
                        <div className="meta-item">
                          <span className="meta-label">Congress: </span>
                          <span className="meta-value"> {GenerateArrayStrings(
                            this.state.item.congressName
                          )}</span>
                        </div>
                      )}
                    {this.state.item.literatureSource && (
                      <div className="meta-item">
                        <span className="meta-label">Source:</span>
                        <span className="meta-value">{this.state.item.literatureSource}</span>
                      </div>
                    )}
                    {this.state.item.docType !== undefined &&
                      this.state.item.docType.length > 0 && (
                        <div className="meta-item">
                          <span className="meta-label">Document Type: </span>
                          <span className="meta-value">{this.state.item.docType}</span>
                        </div>
                      )}
                  </div>
                  <div className="meta-column">
                    {this.state.item.publicationStatus && (
                      <div className="meta-item">
                        <span className="meta-label">Publication Status: </span>
                        <span className="meta-value">{this.state.item.publicationStatus}</span>
                      </div>
                    )}
                    {this.state.item.protocolIDs !== undefined &&
                      this.state.item.protocolIDs.length > 0 ? (<>
                        {(extractedIds && extractedIds.length > 0 && extractedIds[0]) ? (<div className="meta-item">
                          <span className="meta-label">
                            Protocol ID: </span>
                          <span className="meta-value">
                            <a
                              href="javascript:void(0)"
                              title="Click this field to retrieve all evidence from iMS assigned these Protocol IDs/Numbers. This will appear in a new browser tab"
                              onClick={(evt) =>
                                this.handleProtocolID(
                                  extractedIds[0].split(";")
                                )
                              }>
                              {GenerateArrayStrings(
                                ctNames.concat(extractedIds[0].split(";"))
                              )}
                            </a>
                          </span>
                        </div>) : (<div className="meta-item">
                          <span className="meta-label">Protocol ID: </span>
                          <span className="meta-value"><a
                            href="javascript:void(0)"
                            title="Click this field to retrieve all evidence from iMS assigned these Protocol IDs/Numbers. This will appear in a new browser tab"
                            onClick={(evt) =>
                              this.handleProtocolID(
                                extractedIds[1].split(";")
                              )
                            }
                          >
                            {GenerateArrayStrings(
                              ctNames.concat(extractedIds[1].split(";"))
                            )}
                          </a>
                          </span>
                        </div>)}
                      </>
                    ) : (
                      ctNames &&
                      ctNames.length > 0 && (<div className="meta-item">
                        <span className="meta-label">Protocol No: </span>
                        <span className="meta-value">{GenerateArrayStrings(ctNames)}</span>
                      </div>)
                    )}
                    {this.state.item.phaseOfStudy !== undefined &&
                      this.state.item.phaseOfStudy.length > 0 && (
                        <div className="meta-item">
                          <span className="meta-label">Phase of Study: </span>
                          <span className="meta-value">
                            {GenerateArrayStrings(
                              this.state.item.phaseOfStudy
                            )}
                          </span>
                        </div>
                      )}
                    {this.state.item.pmID !== undefined &&
                      this.state.item.pmID.length > 0 && (
                        <div className="meta-item">
                          <span className="meta-label">PubMed ID: </span>
                          <span className="meta-value">    <a
                            href="javascript:void(0)"
                            title="Click this field to view the abstract in PubMed. This will appear in a new browser tab"
                            onClick={(e) =>
                              this.handlePubMedID(this.state.item.pmID)
                            }
                          >
                            {this.state.item.pmID}
                          </a></span>
                        </div>
                      )}
                    {extractedIds[1] && (
                      <div className="meta-item">
                        <span className="meta-label">NCTID: </span>
                        <span className="meta-value">{this.renderNCThyperas(
                          extractedIds[1].split(";")
                        )}</span>
                      </div>
                    )}
                    {this.state.item.languages ? (
                      <div className="meta-item">
                        <span className="meta-label">Language: </span>
                        <span className="meta-value">{this.state.item.languages}</span>
                      </div>
                    ) : (
                      <div className="meta-item">
                        <span className="meta-label">Language: </span>
                        <span className="meta-value">English</span>
                      </div>
                    )}

                    <div className="meta-item">
                      <span className="meta-label">Content Source: </span>
                      <span className="meta-value">iMedical Knowledge Vault</span>
                    </div>
                    <div className="meta-item">
                      <span className="meta-label">Status: </span>
                      <span className="meta-value">{this.state.item.status}</span>
                    </div>

                    {/* {this.state.item.pmID !== undefined &&
                          this.state.item.pmID.length > 0 && (
                            <div className="meta-item">
                              <OrderFromRightFind pubMedId={this.state.item.pmID} />
                            </div>
                          )} */}
                  </div>
                </div>


                {this.state.item.pmID !== undefined &&
                  this.state.item.pmID.length > 0 && (<div className="doc-row meta-row" style={{ overflow: "hidden" }}>
                    {(true) ? <>
                      <a
                        className="action-badge"
                        data-color="Gray"
                        data-icon-left="true"
                        data-icon-right="false"
                        data-size="S"
                        data-style="Light background"
                        target="_blank"
                        href={`https://www.rightfind.com/vlib/order/orderform.aspx?ClientId=60&qlu=${this.state.item.pmID}`}
                        style={{ overflow: "hidden" }}
                      >
                        <svg width="16" height="16" viewBox="0 0 16 16" style={{ float: "left" }} fill="none" xmlns="http://www.w3.org/2000/svg" xlinkTitle="">
                          <title>You have the digital rights to use the full document associated with this citation for any internal purpose. For other usages, including External Reactive Use, Proactive Use, Transmission to a Regulatory Agency, or Special Orders of charts, tables, etc., click on this option to order via RightFind and select the appropriate usage option.</title>
                          <g clip-path="url(#clip0_676_2117)">
                            <path d="M8.00016 10.6667V8.00001M8.00016 5.33334H8.00683M14.6668 8.00001C14.6668 11.6819 11.6821 14.6667 8.00016 14.6667C4.31826 14.6667 1.3335 11.6819 1.3335 8.00001C1.3335 4.31811 4.31826 1.33334 8.00016 1.33334C11.6821 1.33334 14.6668 4.31811 14.6668 8.00001Z" stroke="#81766F" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round" />
                          </g>
                          <defs>
                            <clipPath id="clip0_676_2117">
                              <rect width="16" height="16" fill="white" />
                            </clipPath>
                          </defs>
                        </svg>

                        <div className="badge-text" style={{ float: "left" }} >Order for RightFind for additional usage</div>
                      </a>
                    </> : <GenAIOrderFromRightFind pubMedId={this.state.item.pmID} />}
                  </div>)}
                <div className="doc-row meta-row">
                  {this.state.item.keyTakeaways && (
                    <div className="PHM-MetaDataProperty">
                      <div style={{ display: "block" }}>
                        {(true) ? <>
                          <div className="gen-ai-key-takeaways">
                            <div className="gen-ai-key-takeaways__badge">
                              <svg width="16" height="16" viewBox="0 0 16 16" fill="none" xmlns="http://www.w3.org/2000/svg">
                                <title>The content included in the Key Takeaways field is created by the US Medical Information and EMEA Scientific Knowledge Management teams to support consistent messaging around important published scientific evidence.</title>
                                <g clip-path="url(#clip0_1446_8959)">
                                  <path d="M8.00016 10.6666V7.99992M8.00016 5.33325H8.00683M14.6668 7.99992C14.6668 11.6818 11.6821 14.6666 8.00016 14.6666C4.31826 14.6666 1.3335 11.6818 1.3335 7.99992C1.3335 4.31802 4.31826 1.33325 8.00016 1.33325C11.6821 1.33325 14.6668 4.31802 14.6668 7.99992Z" stroke="#F37820" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round" />
                                </g>
                                <defs>
                                  <clipPath id="clip0_1446_8959">
                                    <rect width="16" height="16" fill="white" />
                                  </clipPath>
                                </defs>
                              </svg>
                              <span className="gen-ai-key-takeaways__badge-label">Key Takeaways</span>
                              <svg style={true ? { transform: "rotate(180deg)", cursor: "pointer" } : { cursor: "pointer" }} width="16" height="16" viewBox="0 0 16 16" fill="none" xmlns="http://www.w3.org/2000/svg">
                                <path d="M4 6L8 10L12 6" stroke="#F37820" stroke-width="2" stroke-linecap="round" stroke-linejoin="round" />
                              </svg>
                            </div>
                            <div className="gen-ai-key-takeaways__card" role="region">
                              <div className="gen-ai-key-takeaways__list">
                                <div
                                  className="gen-ai-key-takeaways__row"
                                  role="row"
                                >
                                  {this.textFormatter(this.state.item.keyTakeaways)}
                                </div>

                              </div>
                            </div>

                          </div>
                        </> :
                          <GenAIKeyTakeaways
                            keyTakeaways={this.state.item.keyTakeaways}
                          />}
                      </div>
                    </div>
                  )}
                  {(this.state.item.extractedAbstract && this.state.item.nlpSummary && (window.location.pathname === '/nlpresults' || window.location.pathname === '/results' || window.location.pathname === '/old_results' || window.location.pathname === '/GenAIResults')) && (
                    <div className="PHM-MetaDataProperty">
                      <div style={{ display: "block" }}>
                        <GenAISummary
                          summaryText={this.state.item.extractedAbstract.trim()}
                          sourceItem={this.state.item}
                          customWidth={this.props.customWidth}
                        />
                      </div>
                    </div>
                  )}
                </div>
              </>) : null}
            </div>
          );
        } else if (this.state.item.domain === "SFM" || this.state.item.domain === 'MCP') {
          let url;
          if (this.state.item.fileExtension !== "pdf") {
            url = `/api/dcs-vv/download?connID=${this.state.item.connID}&csID=${this.state.item.csID}&docID=${this.state.item.docID}&fileType=${this.state.item.fileExtension}&docVer=${this.state.item.majorVersionNumber}&fileName=${encodeURIComponent(this.state.item.docTitle.toString().replace(/\n/g, " "))}`;
          } else {
            url = `/api/dcs-vv/download?connID=${this.state.item.connID}&csID=${this.state.item.csID}&docID=${this.state.item.docID}&fileType=${this.state.item.fileExtension}&fileName=${encodeURIComponent(this.state.item.docTitle.toString().replace(/\n/g, " "))}`;
          }
          if (this.state.item.status === "Approved Needs Review") {
            url = url + `&docState=anr`;
          }
          //this.documentUrl(url);
          return (
            <div className="doc-card-inner">
              <div className="doc-row header-row">
                {/* <div className="left-icons">
                  <div className="checkbox-outline" data-size="M" data-state="Enabled">
                    <input type="checkbox" value={this.state.item.docTitle} key={this.state.item.docID + Math.random()} onChange={() => this.props.handelCitationSelect(this.state.documentIndex, this.props.item, this.props.itemTeaser)} checked={this.props.isChecked} style={{ cursor: "pointer", width: "14px", height: "14px" }}  />
                  </div>
                  <div className="small-square">
                    <img src={this.state.collapsed ? JJ_Icon_expandIcon : JJ_Icon_collapseIcon} alt="expand/collapse-icon" width={14} height={14} onClick={this.props.handleExpandCollapse} style={{ marginTop: this.props.customWidth < 600 ? "35%" : null, cursor: "pointer" }} />
                  </div>
                </div> */}
                <div className="doc-title">
                  <a
                    id="docdata"
                    href={window.location.origin + this.urlGenerator(this.state.item)}
                    target="_blank"
                    onClick={this.indexData}
                    data-title={this.state.item.docTitle}
                    data-products={this.state.item.tempJNJDrugs}
                    data-docnumber={this.state.item.documentNumber}
                    data-version={this.state.item.majorVersionNumber}
                    data-contentsource={this.state.item.domain}
                    data-docid={this.state.item.searchID}
                    data-doctype={this.state.item.docType}
                    data-docurl={this.urlGenerator(this.state.item)}
                    data-doclastmodified={this.state.item.createdDate}
                    data-orderedby={orderedBy}
                    data-orderedfor={orderedFor}
                  >
                    {this.state.documentIndex}.{" "}{this.state.item.docTitle}
                  </a>
                </div>
              </div>
              {!this.state.collapsed ? (<>
                {/* Description */}
                {this.props.itemTeaser !== undefined &&
                  this.props.itemTeaser.length > 0 && (
                    <div className="doc-row description-row">
                      <div className="description">
                        {this.convertToHtml(
                          this.generateDocumentTeaser(this.props.itemTeaser)
                        )}
                      </div>
                    </div>
                  )}
                {/* Metadata two-column grid */}
                <div className="doc-row meta-row meta-data-row-bgcolor">
                  <div className="meta-column">
                    {this.state.item.authors !== undefined &&
                      this.state.item.authors.length > 0 ? (
                      <div className="meta-item">
                        <span className="meta-label">Authors: </span>
                        <span className="meta-value">{getVarType(this.state.item.authors) !== "Array"
                          ? this.state.item.authors
                          : GenerateArrayStrings(this.state.item.authors)}</span>
                      </div>) : (this.state.item.owner && (
                        <div className="meta-item">
                          <span className="meta-label">Owner: </span>
                          <span className="meta-value">{this.state.item.owner}</span>
                        </div>
                      ))}
                    {modifiedDate &&
                      this.state.item.modifiedDate !== undefined &&
                      this.state.item.modifiedDate.length > 0 && (
                        <div className="meta-item">
                          <span className="meta-label">Modified Date: </span>
                          <span className="meta-value">{modifiedDate}</span>
                        </div>
                      )}
                    {this.state.item.docType !== undefined &&
                      this.state.item.docType.length > 0 &&
                      this.state.item.domain !== "SFM" && this.state.item.domain !== 'MCP' && (
                        <div className="meta-item">
                          <span className="meta-label">Document Type: </span>
                          {this.state.item.gcsrcontent ? (
                            <span className="meta-value">{this.state.item.docType} - GCSR</span>
                          ) : (
                            <span className="meta-value">{this.state.item.docType}</span>
                          )}
                        </div>
                      )}
                    {this.state.item.presentationType && (
                      <div className="meta-item">
                        <span className="meta-label">Presentation Type: </span>
                        <span className="meta-value">{this.state.item.presentationType}</span>
                      </div>
                    )}
                    {this.state.item.countries !== undefined &&
                      this.state.item.countries.length > 0 && (
                        <div className="meta-item">
                          <span className="meta-label">Country: </span>
                          {this.state.item.countries.includes(
                            "unitedStates"
                          ) ? (
                            <span className="meta-value">United States</span>
                          ) : (<span className="meta-value">{GenerateArrayStrings(
                            this.state.item.countries
                          )}</span>
                          )}
                        </div>
                      )}
                    {this.state.item.languages !== undefined &&
                      this.state.item.languages.length > 0 ? (
                      <div className="meta-item">
                        <span className="meta-label">Language: </span>
                        <span className="meta-value">{this.state.item.languages}</span>
                      </div>
                    ) : (
                      <div className="meta-item">
                        <span className="meta-label">Language: </span>
                        <span className="meta-value">English</span>
                      </div>
                    )}
                    {this.state.item.product !== undefined &&
                      this.state.item.product.length > 0 && (
                        <div className="meta-item">
                          <span className="meta-label">Products: </span>
                          <span className="meta-value">{GenerateArrayStrings(this.state.item.product)}</span>
                        </div>
                      )}
                  </div>
                  <div className="meta-column">
                    {this.state.item.mslTherapeuticArea && (
                      <div className="meta-item">
                        <span className="meta-label">MSL Therapeutic Area: </span>
                        <span className="meta-value">{this.state.item.mslTherapeuticArea}</span>
                      </div>
                    )}
                    {this.state.item.documentNumber && (
                      <div className="meta-item">
                        <span className="meta-label">Document Number: </span>
                        <span className="meta-value">{this.state.item.documentNumber}</span>
                      </div>
                    )}
                    {this.state.item.majorVersionNumber && (
                      <div className="meta-item">
                        <span className="meta-label">Major Version: </span>
                        <span className="meta-value">{this.state.item.majorVersionNumber}</span>
                      </div>
                    )}
                    <div className="meta-item">
                      <span className="meta-label">Content Source: </span>
                      <span className="meta-value">iMedical Knowledge Vault</span>
                    </div>
                    {this.state.item.status && (
                      <div className="meta-item">
                        <span className="meta-label">Status: </span>
                        <span className="meta-value">{this.state.item.status}</span>
                      </div>
                    )}
                    {/* {this.state.item.targetAudience &&
                          this.state.item.targetAudience.length > 0 && (
                            <div className="meta-item">
                              <span className="meta-label">Target Audience: </span>
                              <span className="meta-value">{this.state.item.targetAudience.join('; ')}</span>
                            </div>
                          )} */}
                  </div>
                </div>
              </>) : null}
            </div>
          );
        } else if (this.state.item.domain === "GCSR") {
          let url;
          if (this.state.item.fileExtension !== "pdf") {
            url = `/api/dcs-vv/download?connID=${this.state.item.connID}&csID=${this.state.item.csID}&docID=${this.state.item.docID}&fileType=${this.state.item.fileExtension}&docVer=${this.state.item.majorVersionNumber}&fileName=${encodeURIComponent(this.state.item.docTitle.toString().replace(/\n/g, " "))}`;
          } else {
            url = `/api/dcs-vv/download?connID=${this.state.item.connID}&csID=${this.state.item.csID}&docID=${this.state.item.docID}&fileType=${this.state.item.fileExtension}&fileName=${encodeURIComponent(this.state.item.docTitle.toString().replace(/\n/g, " "))}`;
          }
          if (this.state.item.status === "Approved Needs Review") {
            url = url + `&docState=anr`;
          }
          //this.documentUrl(url);
          return (
            <div className="doc-card-inner">
              <div className="doc-row header-row">
                {/* <div className="left-icons">
                  <div className="checkbox-outline" data-size="M" data-state="Enabled">
                    <input type="checkbox" value={this.state.item.docTitle} key={this.state.item.docID + Math.random()} onChange={() => this.props.handelCitationSelect(this.state.documentIndex, this.props.item, this.props.itemTeaser)} checked={this.props.isChecked} style={{ cursor: "pointer", width: "14px", height: "14px" }}  />
                  </div>
                  <div className="small-square">
                    <img src={this.state.collapsed ? JJ_Icon_expandIcon : JJ_Icon_collapseIcon} alt="expand/collapse-icon" width={14} height={14} onClick={this.props.handleExpandCollapse} style={{ marginTop: this.props.customWidth < 600 ? "35%" : null, cursor: "pointer" }} />
                  </div>
                </div> */}

                <div className="doc-title">

                  <a
                    id="docdata"
                    href={window.location.origin + this.urlGenerator(this.state.item)}
                    target="_blank"
                    onClick={this.indexData}
                    data-title={this.state.item.docTitle}
                    data-products={this.state.item.tempJNJDrugs}
                    data-docnumber={this.state.item.documentNumber}
                    data-version={this.state.item.majorVersionNumber}
                    data-contentsource={this.state.item.domain}
                    data-docid={this.state.item.searchID}
                    data-doctype={this.state.item.docType}
                    data-docurl={this.urlGenerator(this.state.item)}
                    data-doclastmodified={this.state.item.createdDate}
                    data-orderedby={orderedBy}
                    data-orderedfor={orderedFor}
                  >
                    {this.state.documentIndex}.{" "}{this.state.item.docTitle}
                  </a>

                </div>

              </div>
              {!this.state.collapsed ? (<>
                {/* Description */}
                {this.props.itemTeaser !== undefined &&
                  this.props.itemTeaser.length > 0 && (
                    <div className="doc-row description-row">
                      <div className="description">
                        {this.convertToHtml(
                          this.generateDocumentTeaser(this.props.itemTeaser)
                        )}
                      </div>
                    </div>
                  )}
                {/* Metadata two-column grid */}
                <div className="doc-row meta-row meta-data-row-bgcolor">
                  <div className="meta-column">
                    {this.state.item.authors !== undefined &&
                      this.state.item.authors.length > 0 ? (
                      <div className="meta-item">
                        <span className="meta-label">Authors: </span>
                        <span className="meta-value">{getVarType(this.state.item.authors) !== "Array"
                          ? this.state.item.authors
                          : GenerateArrayStrings(this.state.item.authors)}</span>
                      </div>) : (this.state.item.owner && (
                        <div className="meta-item">
                          <span className="meta-label">Owner: </span>
                          <span className="meta-value">{this.state.item.owner}</span>
                        </div>
                      ))}
                    {modifiedDate &&
                      this.state.item.modifiedDate !== undefined &&
                      this.state.item.modifiedDate.length > 0 && (
                        <div className="meta-item">
                          <span className="meta-label">Modified Date: </span>
                          <span className="meta-value">{modifiedDate}</span>
                        </div>
                      )}
                    {this.state.item.docType !== undefined &&
                      this.state.item.docType.length > 0 &&
                      this.state.item.domain !== "SFM" && this.state.item.domain !== 'MCP' && (
                        <div className="meta-item">
                          <span className="meta-label">Document Type: </span>
                          {this.state.item.gcsrcontent ? (
                            <span className="meta-value">{this.state.item.docType} - GCSR</span>
                          ) : (
                            <span className="meta-value">{this.state.item.docType} - GCSR</span>
                          )}
                        </div>
                      )}
                    {this.state.item.presentationType && (
                      <div className="meta-item">
                        <span className="meta-label">Presentation Type: </span>
                        <span className="meta-value">{this.state.item.presentationType}</span>
                      </div>
                    )}
                    {this.state.item.countries !== undefined &&
                      this.state.item.countries.length > 0 && (
                        <div className="meta-item">
                          <span className="meta-label">Country: </span>
                          {this.state.item.countries.includes(
                            "unitedStates"
                          ) ? (
                            <span className="meta-value">United States</span>
                          ) : (<span className="meta-value">{GenerateArrayStrings(
                            this.state.item.countries
                          )}</span>
                          )}
                        </div>
                      )}
                    {this.state.item.languages !== undefined &&
                      this.state.item.languages.length > 0 ? (
                      <div className="meta-item">
                        <span className="meta-label">Language: </span>
                        <span className="meta-value">{this.state.item.languages}</span>
                      </div>
                    ) : (
                      <div className="meta-item">
                        <span className="meta-label">Language: </span>
                        <span className="meta-value">English</span>
                      </div>
                    )}
                    {this.state.item.product !== undefined &&
                      this.state.item.product.length > 0 && (
                        <div className="meta-item">
                          <span className="meta-label">Products: </span>
                          <span className="meta-value">{GenerateArrayStrings(this.state.item.product)}</span>
                        </div>
                      )}
                  </div>

                  <div className="meta-column">
                    {this.state.item.mslTherapeuticArea && (
                      <div className="meta-item">
                        <span className="meta-label">MSL Therapeutic Area: </span>
                        <span className="meta-value">{this.state.item.mslTherapeuticArea}</span>
                      </div>
                    )}
                    {this.state.item.documentNumber && (
                      <div className="meta-item">
                        <span className="meta-label">Document Number: </span>
                        <span className="meta-value">{this.state.item.documentNumber}</span>
                      </div>
                    )}

                    {this.state.item.majorVersionNumber && (
                      <div className="meta-item">
                        <span className="meta-label">Major Version: </span>
                        <span className="meta-value">{this.state.item.majorVersionNumber}</span>
                      </div>
                    )}

                    <div className="meta-item">
                      <span className="meta-label">Content Source: </span>
                      <span className="meta-value">iMedical Knowledge Vault</span>
                    </div>

                    {this.state.item.status && (
                      <div className="meta-item">
                        <span className="meta-label">Status: </span>
                        <span className="meta-value">{this.state.item.status}</span>
                      </div>
                    )}
                  </div>
                </div>
              </>) : null}
            </div>
          );
        }
        else if (this.state.item.domain === "SRAP") {
          let url;
          if (this.state.item.fileExtension !== "pdf") {
            url = `/api/dcs-vv/download?connID=${this.state.item.connID}&csID=${this.state.item.csID}&docID=${this.state.item.docID}&fileType=${this.state.item.fileExtension}&docVer=${this.state.item.majorVersionNumber}&fileName=${encodeURIComponent(this.state.item.docTitle.toString().replace(/\n/g, " "))}`;
          } else {
            url = `/api/dcs-vv/download?connID=${this.state.item.connID}&csID=${this.state.item.csID}&docID=${this.state.item.docID}&fileType=${this.state.item.fileExtension}&fileName=${encodeURIComponent(this.state.item.docTitle.toString().replace(/\n/g, " "))}`;
          }
          if (this.state.item.status === "Approved Needs Review") {
            url = url + `&docState=anr`;
          }
          //this.documentUrl(url);
          return (
            <div className="doc-card-inner">
              <div className="doc-row header-row">
                {/* <div className="left-icons">
                  <div className="checkbox-outline" data-size="M" data-state="Enabled">
                    <input type="checkbox" value={this.state.item.docTitle} key={this.state.item.docID + Math.random()} onChange={() => this.props.handelCitationSelect(this.state.documentIndex, this.props.item, this.props.itemTeaser)} checked={this.props.isChecked} style={{ cursor: "pointer", width: "14px", height: "14px" }}  />
                  </div>
                  <div className="small-square">
                    <img src={this.state.collapsed ? JJ_Icon_expandIcon : JJ_Icon_collapseIcon} alt="expand/collapse-icon" width={14} height={14} onClick={this.props.handleExpandCollapse} style={{ marginTop: this.props.customWidth < 600 ? "35%" : null, cursor: "pointer" }} />
                  </div>
                </div> */}

                <div className="doc-title">
                  <a
                    id="docdata"
                    href={window.location.origin + this.urlGenerator(this.state.item)}
                    target="_blank"
                    onClick={this.indexData}
                    data-title={this.state.item.docTitle}
                    data-products={this.state.item.tempJNJDrugs}
                    data-docnumber={this.state.item.documentNumber}
                    data-version={this.state.item.majorVersionNumber}
                    data-contentsource={this.state.item.domain}
                    data-docid={this.state.item.searchID}
                    data-doctype={this.state.item.docType}
                    data-docurl={this.urlGenerator(this.state.item)}
                    data-doclastmodified={this.state.item.createdDate}
                    data-orderedby={orderedBy}
                    data-orderedfor={orderedFor}
                  >
                    {this.state.documentIndex}.{" "}{this.state.item.docTitle}
                  </a>

                </div>

              </div>
              {!this.state.collapsed ? (<>
                {/* Description */}
                {this.props.itemTeaser !== undefined &&
                  this.props.itemTeaser.length > 0 && (
                    <div className="doc-row description-row">
                      <div className="description">
                        {this.convertToHtml(
                          this.generateDocumentTeaser(this.props.itemTeaser)
                        )}
                      </div>
                    </div>
                  )}
                {/* Metadata two-column grid */}
                <div className="doc-row meta-row meta-data-row-bgcolor">
                  <div className="meta-column">
                    {this.state.item.authors !== undefined &&
                      this.state.item.authors.length > 0 ? (
                      <div className="meta-item">
                        <span className="meta-label">Authors: </span>
                        <span className="meta-value">{getVarType(this.state.item.authors) !== "Array"
                          ? this.state.item.authors
                          : GenerateArrayStrings(this.state.item.authors)}</span>
                      </div>) : (this.state.item.owner && (
                        <div className="meta-item">
                          <span className="meta-label">Owner: </span>
                          <span className="meta-value">{this.state.item.owner}</span>
                        </div>
                      ))}
                    {modifiedDate &&
                      this.state.item.modifiedDate !== undefined &&
                      this.state.item.modifiedDate.length > 0 && (
                        <div className="meta-item">
                          <span className="meta-label">Modified Date: </span>
                          <span className="meta-value">{modifiedDate}</span>
                        </div>
                      )}

                    {this.state.item.presentationType && (
                      <div className="meta-item">
                        <span className="meta-label">Presentation Type: </span>
                        <span className="meta-value">{this.state.item.presentationType}</span>
                      </div>
                    )}
                    {this.state.item.countries !== undefined &&
                      this.state.item.countries.length > 0 && (
                        <div className="meta-item">
                          <span className="meta-label">Country: </span>
                          {this.state.item.countries.includes(
                            "unitedStates"
                          ) ? (
                            <span className="meta-value">United States</span>
                          ) : (<span className="meta-value">{GenerateArrayStrings(
                            this.state.item.countries
                          )}</span>
                          )}
                        </div>
                      )}
                    {this.state.item.languages !== undefined &&
                      this.state.item.languages.length > 0 ? (
                      <div className="meta-item">
                        <span className="meta-label">Language: </span>
                        <span className="meta-value">{this.state.item.languages}</span>
                      </div>
                    ) : (
                      <div className="meta-item">
                        <span className="meta-label">Language: </span>
                        <span className="meta-value">English</span>
                      </div>
                    )}
                    {this.state.item.product !== undefined &&
                      this.state.item.product.length > 0 && (
                        <div className="meta-item">
                          <span className="meta-label">Products: </span>
                          <span className="meta-value">{GenerateArrayStrings(this.state.item.product)}</span>
                        </div>
                      )}
                  </div>

                  <div className="meta-column">

                    {this.state.item.documentNumber && (
                      <div className="meta-item">
                        <span className="meta-label">Document Number: </span>
                        <span className="meta-value">{this.state.item.documentNumber}</span>
                      </div>
                    )}

                    {this.state.item.majorVersionNumber && (
                      <div className="meta-item">
                        <span className="meta-label">Major Version: </span>
                        <span className="meta-value">{this.state.item.majorVersionNumber}</span>
                      </div>
                    )}

                    <div className="meta-item">
                      <span className="meta-label">Content Source: </span>
                      <span className="meta-value">iMedical Knowledge Vault</span>
                    </div>

                    {this.state.item.status && (
                      <div className="meta-item">
                        <span className="meta-label">Status: </span>
                        <span className="meta-value">{this.state.item.status}</span>
                      </div>
                    )}
                  </div>
                </div>
              </>) : null}
            </div>
          );
        }
        else if (this.state.item.domain === "SR" || this.state.item.domain === "CMIR_LATAM") {
          //let userid=localStorage.getItem('username').toLowerCase().replace(/"/g,'').split('@')[0]
          let url;
          if (this.state.item.fileExtension !== "pdf") {
            url = `/api/dcs-vv/download?connID=${this.state.item.connID}&csID=${this.state.item.csID}&docID=${this.state.item.docID}&fileType=${this.state.item.fileExtension}&docVer=${this.state.item.majorVersionNumber}&fileName=${encodeURIComponent(this.state.item.docTitle.toString().replace(/\n/g, " "))}`;
          } else {
            url = `/api/dcs-vv/download?connID=${this.state.item.connID}&csID=${this.state.item.csID}&docID=${this.state.item.docID}&fileType=${this.state.item.fileExtension}&fileName=${encodeURIComponent(this.state.item.docTitle.toString().replace(/\n/g, " "))}`;
          }
          if (this.state.item.status === "Approved Needs Review") {
            url = url + `&docState=anr`;
          }
          if (this.state.item.enclosureDocID) {
            url += `&enclosureID=${this.state.item.enclosureDocID}`
          }
          //this.documentUrl(url);
          return (
            <div className="doc-card-inner">
              <div className="doc-row header-row">
                {/* <div className="left-icons">
                  <div className="checkbox-outline" data-size="M" data-state="Enabled">
                    <input type="checkbox" value={this.state.item.docTitle} key={this.state.item.docID + Math.random()} onChange={() => this.props.handelCitationSelect(this.state.documentIndex, this.props.item, this.props.itemTeaser)} checked={this.props.isChecked} style={{ cursor: "pointer", width: "14px", height: "14px" }}  />
                  </div>
                  <div className="small-square">
                    <img src={this.state.collapsed ? JJ_Icon_expandIcon : JJ_Icon_collapseIcon} alt="expand/collapse-icon" width={14} height={14} onClick={this.props.handleExpandCollapse} style={{ marginTop: this.props.customWidth < 600 ? "35%" : null, cursor: "pointer" }} />
                  </div>
                </div> */}
                <div className="doc-title">
                  <a
                    id="docdata"
                    href={window.location.origin + this.urlGenerator(this.state.item)}
                    target="_blank"
                    onClick={this.indexData}
                    data-title={this.state.item.docTitle}
                    data-products={this.state.item.tempJNJDrugs}
                    data-docnumber={this.state.item.documentNumber}
                    data-version={this.state.item.majorVersionNumber}
                    data-contentsource={this.state.item.domain}
                    data-docid={this.state.item.searchID}
                    data-doctype={this.state.item.docType}
                    data-docurl={this.urlGenerator(this.state.item)}
                    data-doclastmodified={this.state.item.createdDate}
                    data-orderedby={orderedBy}
                    data-orderedfor={orderedFor}
                  >
                    {this.state.documentIndex}.{" "}{this.state.item.docTitle}
                  </a>

                </div>

              </div>
              {!this.state.collapsed ? (<>
                {/* Description */}
                {this.props.itemTeaser !== undefined &&
                  this.props.itemTeaser.length > 0 && (
                    <div className="doc-row description-row">
                      <div className="description">
                        {this.convertToHtml(
                          this.generateDocumentTeaser(this.props.itemTeaser)
                        )}
                      </div>
                    </div>
                  )}
                {/* Metadata two-column grid */}
                <div className="doc-row meta-row meta-data-row-bgcolor">
                  <div className="meta-column">
                    {this.state.item.authors !== undefined &&
                      this.state.item.authors.length > 0 ? (
                      <div className="meta-item">
                        <span className="meta-label">Authors: </span>
                        <span className="meta-value">{getVarType(this.state.item.authors) !== "Array"
                          ? this.state.item.authors
                          : GenerateArrayStrings(this.state.item.authors)}</span>
                      </div>) : (this.state.item.owner && (
                        <div className="meta-item">
                          <span className="meta-label">Owner: </span>
                          <span className="meta-value">{this.state.item.owner}</span>
                        </div>
                      ))}
                    {modifiedDate &&
                      this.state.item.modifiedDate !== undefined &&
                      this.state.item.modifiedDate.length > 0 && (
                        <div className="meta-item">
                          <span className="meta-label">Modified Date: </span>
                          <span className="meta-value">{modifiedDate}</span>
                        </div>
                      )}
                    {this.state.item.docType !== undefined &&
                      this.state.item.docType.length > 0 &&
                      this.state.item.domain !== "SFM" && this.state.item.domain !== 'MCP' && (
                        <div className="meta-item">
                          <span className="meta-label">Document Type: </span>
                          {this.state.item.gcsrcontent ? (
                            <span className="meta-value">{this.state.item.docType} - GCSR</span>
                          ) : (
                            <span className="meta-value">{this.state.item.docType}</span>
                          )}
                        </div>
                      )}

                    {this.state.item.presentationType && (
                      <div className="meta-item">
                        <span className="meta-label">Presentation Type: </span>
                        <span className="meta-value">{this.state.item.presentationType}</span>
                      </div>
                    )}
                    {this.state.item.countries !== undefined &&
                      this.state.item.countries.length > 0 && (
                        <div className="meta-item">
                          <span className="meta-label">Country: </span>
                          {this.state.item.countries.includes(
                            "unitedStates"
                          ) ? (
                            <span className="meta-value">United States</span>
                          ) : (<span className="meta-value">{GenerateArrayStrings(
                            this.state.item.countries
                          )}</span>
                          )}
                        </div>
                      )}
                    {this.state.item.languages !== undefined &&
                      this.state.item.languages.length > 0 ? (
                      <div className="meta-item">
                        <span className="meta-label">Language: </span>
                        <span className="meta-value">{this.state.item.languages}</span>
                      </div>
                    ) : (
                      <div className="meta-item">
                        <span className="meta-label">Language: </span>
                        <span className="meta-value">English</span>
                      </div>
                    )}
                    {this.state.item.product !== undefined &&
                      this.state.item.product.length > 0 && (
                        <div className="meta-item">
                          <span className="meta-label">Products: </span>
                          {/* <span className="meta-value" showFilters={showFilters}>{GenerateArrayStrings(this.state.item.product)}</span> */}
                          <span className="meta-value" style={{ wordWrap: "break-word" }}>{GenerateArrayStrings(this.state.item.product)}</span>
                        </div>
                      )}
                  </div>

                  <div className="meta-column">

                    {this.state.item.documentNumber && (
                      <div className="meta-item">
                        <span className="meta-label">Document Number: </span>
                        <span className="meta-value">{this.state.item.documentNumber}</span>
                      </div>
                    )}

                    {this.state.item.majorVersionNumber && (
                      <div className="meta-item">
                        <span className="meta-label">Major Version: </span>
                        <span className="meta-value">{this.state.item.majorVersionNumber}</span>
                      </div>
                    )}

                    <div className="meta-item">
                      <span className="meta-label">Content Source: </span>
                      <span className="meta-value">iMedical Knowledge Vault</span>
                    </div>

                    {this.state.item.status && (
                      <div className="meta-item">
                        <span className="meta-label">Status: </span>
                        <span className="meta-value">{this.state.item.status}</span>
                      </div>
                    )}
                    {this.state.item.targetAudience &&
                      this.state.item.targetAudience.length > 0 && (
                        <div className="meta-item">
                          <span className="meta-label">Target Audience: </span>
                          <span className="meta-value">{this.state.item.targetAudience.join('; ')}</span>
                        </div>
                      )}
                  </div>
                </div>
                <div className="doc-row meta-row">
                  {(this.state.item.enclosureDocID && this.state.item.enclosureTitle) && (
                    <div className="PHM-MetaDataProperty">
                      <div style={{ display: "block" }}>
                        <GenAIEnclosure
                          enclosureDocID={this.state.item.enclosureDocID}
                          enclosureTitle={this.state.item.enclosureTitle}
                          downloadURL={url}
                          item={this.state.item}
                          orderedFor={orderedFor}
                          orderedBy={orderedBy}
                          indexData={this.indexData}
                        />
                      </div>
                    </div>
                  )}

                </div>

              </>) : null}
            </div>
          );
        }
        else if (
          this.state.item.domain === "iMR" ||
          this.state.item.domain === "iMR_LATAM" ||
          this.state.item.domain === "iMR_EMEA" ||
          this.state.item.domain === "iMR_ASPAC"
        ) {
          //let userid=localStorage.getItem('username').toLowerCase().replace(/"/g,'').split('@')[0]
          let url;
          if (this.state.item.fileExtension !== "pdf") {
            url = `/api/dcs-vv/download?connID=${this.state.item.connID}&csID=${this.state.item.csID}&docID=${this.state.item.docID}&fileType=${this.state.item.fileExtension}&docVer=${this.state.item.majorVersionNumber}&fileName=${encodeURIComponent(this.state.item.docTitle.toString().replace(/\n/g, " "))}`;
          } else {
            url = `/api/dcs-vv/download?connID=${this.state.item.connID}&csID=${this.state.item.csID}&docID=${this.state.item.docID}&fileType=${this.state.item.fileExtension}&fileName=${encodeURIComponent(this.state.item.docTitle.toString().replace(/\n/g, " "))}`;
          }
          if (this.state.item.status === "Approved Needs Review") {
            url = url + `&docState=anr`;
          }
          let products = "";
          if (this.state.item.product) {
            try {
              products = this.state.item.product.map(x => this.titleCase(x.split('_')[0])).filter(this.onlyUnique).join('; ')
            } catch (error) {
              console.log("error", error);
            }

          }
          //this.documentUrl(url);
          return (
            <div className="doc-card-inner">
              <div className="doc-row header-row">
                {/* <div className="left-icons">
                  <div className="checkbox-outline" data-size="M" data-state="Enabled">
                    <input type="checkbox" value={this.state.item.docTitle} key={this.state.item.docID + Math.random()} onChange={() => this.props.handelCitationSelect(this.state.documentIndex, this.props.item, this.props.itemTeaser)} checked={this.props.isChecked} style={{ cursor: "pointer", width: "14px", height: "14px" }}  />
                  </div>
                  <div className="small-square">
                    <img src={this.state.collapsed ? JJ_Icon_expandIcon : JJ_Icon_collapseIcon} alt="expand/collapse-icon" width={14} height={14} onClick={this.props.handleExpandCollapse} style={{ marginTop: this.props.customWidth < 600 ? "35%" : null, cursor: "pointer" }} />
                  </div>
                </div> */}
                <div className="doc-title">
                  <a
                    id="docdata"
                    href={window.location.origin + this.urlGenerator(this.state.item)}
                    target="_blank"
                    onClick={this.indexData}
                    data-title={this.state.item.docTitle}
                    data-products={this.state.item.tempJNJDrugs}
                    data-docnumber={this.state.item.documentNumber}
                    data-contentsource={this.state.item.domain}
                    data-docid={this.state.item.searchID}
                    data-doctype={this.state.item.docType}
                    data-docurl={this.urlGenerator(this.state.item)}
                    data-doclastmodified={this.state.item.createdDate}
                    data-orderedby={orderedBy}
                    data-orderedfor={orderedFor}
                  >
                    {this.state.documentIndex}.{" "}{this.state.item.docTitle}
                  </a>
                </div>
              </div>
              {!this.state.collapsed ? (<>
                {/* Description */}
                {this.props.itemTeaser !== undefined &&
                  this.props.itemTeaser.length > 0 && (
                    <div className="doc-row description-row">
                      <div className="description">
                        {this.convertToHtml(
                          this.generateDocumentTeaser(this.props.itemTeaser)
                        )}
                      </div>
                    </div>
                  )}
                {/* Metadata two-column grid */}
                <div className="doc-row meta-row meta-data-row-bgcolor">
                  <div className="meta-column">
                    <div className="meta-item">
                      <span className="meta-label">Usage Guidelines: </span>
                      <span className="meta-value">Before external use, you MUST ensure the content is
                        compliant with your local review processes (i.e.
                        medical, legal, compliance, privacy, and regulatory)</span>
                    </div>

                    {this.state.item.name && (
                      <div className="meta-item">
                        <span className="meta-label">Title: </span>
                        <span className="meta-value">{this.state.item.name}</span>
                      </div>
                    )}
                    {this.state.item.owner && (
                      <div className="meta-item">
                        <span className="meta-label">Owner: </span>
                        <span className="meta-value">{this.state.item.owner}</span>
                      </div>
                    )}
                    {this.state.item.product !== undefined &&
                      this.state.item.product.length > 0 && (
                        <div className="meta-item">
                          <span className="meta-label">Products: </span>
                          <span className="meta-value">{products}</span>
                        </div>
                      )}
                    {this.state.item.subProduct && (
                      <div className="meta-item">
                        <span className="meta-label">Sub Product: </span>
                        <span className="meta-value">{this.state.item.subProduct}</span>
                      </div>
                    )}
                    {this.state.item.documentNumber && (
                      <div className="meta-item">
                        <span className="meta-label">Document Number: </span>
                        <span className="meta-value">{this.state.item.documentNumber}</span>
                      </div>
                    )}
                    {this.state.item.majorVersionNumber && (
                      <div className="meta-item">
                        <span className="meta-label">Version: </span>
                        <span className="meta-value">{this.state.item.majorVersionNumber}</span>
                      </div>
                    )}
                    {this.state.item.businessUnit && (
                      <div className="meta-item">
                        <span className="meta-label">Business Unit: </span>
                        <span className="meta-value">{this.state.item.businessUnit}</span>
                      </div>
                    )}
                    {this.state.item.lineOfBusiness && (
                      <div className="meta-item">
                        <span className="meta-label">Line of Business: </span>
                        <span className="meta-value">{this.state.item.lineOfBusiness}</span>
                      </div>
                    )}

                    {this.state.item.approvedDateString && (
                      <div className="meta-item">
                        <span className="meta-label">Approved for Distribution Date: </span>
                        <span className="meta-value">{this.state.item.approvedDateString}</span>
                      </div>
                    )}
                    {this.state.item.expirationDateString && (
                      <div className="meta-item">
                        <span className="meta-label">Expiration Date: </span>
                        <span className="meta-value">{this.state.item.expirationDateString}</span>
                      </div>
                    )}
                    {this.state.item.lastModifiedBy && (
                      <div className="meta-item">
                        <span className="meta-label">Modified by: </span>
                        <span className="meta-value">{this.state.item.lastModifiedBy}</span>
                      </div>
                    )}
                    {this.state.item.type && (
                      <div className="meta-item">
                        <span className="meta-label">Type: </span>
                        <span className="meta-value">{this.state.item.type}</span>
                      </div>
                    )}
                  </div>
                  <div className="meta-column">
                    {this.state.item.subType && (
                      <div className="meta-item">
                        <span className="meta-label">Subtype: </span>
                        <span className="meta-value">{this.state.item.subType}</span>
                      </div>
                    )}
                    {this.state.item.classification && (
                      <div className="meta-item">
                        <span className="meta-label">Classification: </span>
                        <span className="meta-value">{this.state.item.classification}</span>
                      </div>
                    )}
                    {this.state.item.lifecycle && (
                      <div className="meta-item">
                        <span className="meta-label">Lifecycle: </span>
                        <span className="meta-value">{this.state.item.lifecycle}</span>
                      </div>
                    )}
                    {this.state.item.pTargetAudience && (
                      <div className="meta-item">
                        <span className="meta-label">Primary Target Audience: </span>
                        <span className="meta-value">{this.state.item.pTargetAudience}</span>
                      </div>
                    )}
                    {this.state.item.audience && (
                      <div className="meta-item">
                        <span className="meta-label">Audience: </span>
                        <span className="meta-value">{this.state.item.audience}</span>
                      </div>
                    )}
                    {this.state.item.distributedBy && (
                      <div className="meta-item">
                        <span className="meta-label">Distributed by: </span>
                        <span className="meta-value">{this.state.item.distributedBy}</span>
                      </div>
                    )}
                    <div className="meta-item">
                      <span className="meta-label">Language: </span>
                      <span className="meta-value">{this.state.item.languages
                        ? this.state.item.languages
                        : "English"}</span>
                    </div>
                    {this.state.item.status && (
                      <div className="meta-item">
                        <span className="meta-label">Status: </span>
                        <span className="meta-value">{this.state.item.status}</span>
                      </div>
                    )}
                    <div className="meta-item">
                      <span className="meta-label">Content Source: </span>
                      <span className="meta-value">iMedical Review</span>
                    </div>
                    {(this.state.item.domain !== "iMR_LATAM" && this.state.item.domain !== "iMR_EMEA" && this.state.item.domain !== "iMR_ASPAC") && (
                      <div className="meta-item">
                        <span className="meta-label">Related Pieces: </span>
                        <span className="meta-value">There may be pieces related to the Copy Review
                          Piece. To access, you must go to iMR directly.</span>
                      </div>
                    )}
                    {(this.state.item.domain === "iMR_LATAM" || this.state.item.domain === "iMR_EMEA" || this.state.item.domain === "iMR_ASPAC") && (
                      this.state.item.audience && this.state.item.domain === "iMR_LATAM" ? (
                        <div className="meta-item">
                          <span className="meta-label">Presentation Type: </span>
                          <span className="meta-value">{this.state.item.audience.split(';').join(', ')}</span>
                        </div>
                      ) : (
                        <div className="meta-item">
                          <span className="meta-label">Presentation Type: </span>
                          {this.state.item.domain === "iMR_EMEA" && <span className="meta-value">Reactive</span>}
                          {this.state.item.domain === "iMR_ASPAC" && <span className="meta-value">Proactive</span>}
                        </div>
                      )
                    )}
                    {(this.state.item.domain === "iMR_LATAM" || this.state.item.domain === "iMR_EMEA" || this.state.item.domain === "iMR_ASPAC") ? (
                      this.state.item.countries !== undefined &&
                      this.state.item.countries.length > 0 && (
                        <div className="meta-item">
                          <span className="meta-label">Country: </span>
                          <span className="meta-value"> {GenerateArrayStrings(this.state.item.countries)}</span>
                        </div>
                      )
                    ) : (
                      <div className="meta-item">
                        <span className="meta-label">Country: </span>
                        <span className="meta-value">United States</span>
                      </div>
                    )}
                  </div>
                </div>
                <div className="doc-row meta-row">
                  {this.state.item.docItemDescription && (
                    <div className="PHM-MetaDataProperty">
                      <div style={{ display: "block" }}>
                        <GenAIDocumentDescriptor
                          docItemDescription={
                            this.state.item.docItemDescription
                          }
                        />
                      </div>
                    </div>
                  )}
                </div>
              </>) : null}
            </div>
          );
        }
        else if (this.state.item.domain === "CTGov") {
          //let nctId = this.state.item.protocolIDs.find(elm => elm.startsWith('NCT'))
          // let url = `https://clinicaltrials.gov/ct2/show/${this.state.item.docTitle}`;
          let url = `https://clinicaltrials.gov/ct2/show/${this.state.item.docID}`;
          //this.documentUrl(url);
          return (
            <div className="doc-card-inner">
              <div className="doc-row header-row">
                {/* <div className="left-icons">
                  <div className="checkbox-outline" data-size="M" data-state="Enabled">
                    <input type="checkbox" value={this.state.item.docTitle} key={this.state.item.docID + Math.random()} onChange={() => this.props.handelCitationSelect(this.state.documentIndex, this.props.item, this.props.itemTeaser)} checked={this.props.isChecked} style={{ cursor: "pointer", width: "14px", height: "14px" }}  />
                  </div>
                  <div className="small-square">
                    <img src={this.state.collapsed ? JJ_Icon_expandIcon : JJ_Icon_collapseIcon} alt="expand/collapse-icon" width={14} height={14} onClick={this.props.handleExpandCollapse} style={{ marginTop: this.props.customWidth < 600 ? "35%" : null, cursor: "pointer" }} />
                  </div>
                </div> */}
                <div className="doc-title">
                  <a
                    id="docdata"
                    href={url}
                    target="_blank"
                    // onClick={this.indexData}
                    data-title={this.state.item.docTitle}
                    data-products={this.state.item.tempJNJDrugs}
                    data-docnumber={this.state.item.documentNumber}
                    data-contentsource={this.state.item.domain}
                    data-docid={this.state.item.searchID}
                    data-doctype={this.state.item.docType}
                    data-docurl={url}
                    data-doclastmodified={this.state.item.createdDate}
                    data-orderedby={orderedBy}
                    data-orderedfor={orderedFor}
                  >
                    {this.state.documentIndex}.{" "}{this.state.item.docTitle}
                  </a>
                </div>
              </div>
              {!this.state.collapsed ? (<>
                {/* Description */}
                {this.props.itemTeaser !== undefined &&
                  this.props.itemTeaser.length > 0 && (
                    <div className="doc-row description-row">
                      <div className="description">
                        {this.convertToHtml(
                          this.generateDocumentTeaser(this.props.itemTeaser)
                        )}
                      </div>
                    </div>
                  )}

                {/* Metadata two-column grid */}
                <div className="doc-row meta-row meta-data-row-bgcolor">
                  <div className="meta-column">
                    {this.state.item.docType !== undefined &&
                      this.state.item.docType.length > 0 && (
                        <div className="meta-item">
                          <span className="meta-label">Document Type: </span>
                          <span className="meta-value">{this.state.item.docType}</span>
                        </div>)}
                    {this.state.item.lastUpdated && (
                      <div className="meta-item">
                        <span className="meta-label">Last Updated:</span>
                        <span className="meta-value">{moment(this.state.item.lastUpdated).format("D-MMM-YYYY")}</span>
                      </div>
                    )}
                    {this.state.item.lastVerified && (
                      <div className="meta-item">
                        <span className="meta-label">Last Verified: </span>
                        <span className="meta-value">{this.state.item.lastVerified}</span>
                      </div>
                    )}
                    {this.state.item.leadSponsor && (
                      <div className="meta-item">
                        <span className="meta-label">Sponsor: </span>
                        <span className="meta-value">{this.state.item.leadSponsor}</span>
                      </div>
                    )}
                    {this.state.item.protocolIDs !== undefined &&
                      this.state.item.protocolIDs.length > 0 ? (
                      <div className="meta-item">
                        <span className="meta-label" >
                          Protocol ID:</span>
                        <span className="meta-value">
                          <a
                            href="javascript:void(0)"
                            title="Click this field to retrieve all evidence from iMS assigned these Protocol IDs/Numbers. This will appear in a new browser tab"
                            onClick={(evt) =>
                              this.handleProtocolID(
                                this.state.item.protocolIDs
                              )
                            }
                          >
                            {GenerateArrayStrings(
                              ctNames.concat(this.state.item.protocolIDs)
                            )}
                            {/* {GenerateArrayStrings(this.state.item.protocolIDs)} */}
                          </a></span>
                      </div>
                    ) : (
                      ctNames &&
                      ctNames.length > 0 && (<div className="meta-item">
                        <span className="meta-label">Protocol No: </span>
                        <span className="meta-value">{GenerateArrayStrings(ctNames)}</span>
                      </div>))
                    }
                    {this.state.item.intervention && (
                      <div className="meta-item">
                        <span className="meta-label">Intervention: </span>
                        {/* <span className="meta-value">{this.state.item.intervention}</span> */}
                        <span className="meta-value" style={{ wordWrap: "break-word" }}>{this.state.item.intervention}</span>
                      </div>
                    )}
                    {this.state.item.condition && (
                      <div className="meta-item">
                        <span className="meta-label">Condition: </span>
                        <span className="meta-value">{this.state.item.condition}
                        </span>
                      </div>
                    )}
                    {(this.state.item.phaseOfStudy !== undefined &&
                      this.state.item.phaseOfStudy.length > 0 && (
                        <div className="meta-item">
                          <span className="meta-label">Phase: </span>
                          <span className="meta-value"> {GenerateArrayStrings(
                            this.state.item.phaseOfStudy
                          )}</span>
                        </div>)
                    )}

                    {this.state.item.languages ? (
                      <div className="meta-item">
                        <span className="meta-label">Language: </span>
                        <span className="meta-value">{this.state.item.languages}</span>
                      </div>
                    ) : (
                      <div className="meta-item">
                        <span className="meta-label">Language: </span>
                        <span className="meta-value">English</span>
                      </div>
                    )}
                    {this.state.item.overallStatus && (

                      <div className="meta-item">
                        <span className="meta-label">Overall Status: </span>
                        <span className="meta-value">{this.state.item.overallStatus}  </span>
                      </div>
                    )}
                    {this.state.item.startDate && (
                      <div className="meta-item">
                        <span className="meta-label">Start Date</span>
                        <span className="meta-value">{this.state.item.startDate} </span>
                      </div>
                    )}
                  </div>
                  <div className="meta-column">
                    {this.state.item.endDate && (
                      <div className="meta-item">
                        <span className="meta-label">End Date </span>
                        <span className="meta-value">{this.state.item.endDate}  </span>
                      </div>
                    )}
                  </div>
                </div>
              </>) : null}
            </div>
          );
        }
        else if (this.state.item.domain === "IROs") {
          let url = `/api/dcs-spo/download?connID=${this.state.item.connID}&csID=${this.state.item.csID}&docID=${this.state.item.docID}&fileType=${this.state.item.fileExtension}&fileName=${encodeURIComponent(this.state.item.docTitle)}`;
          let downloadurl = `/api/dcs-spo/download?connID=${this.state.item.connID}%26csID=${this.state.item.csID}%26docID=${this.state.item.docID}%26fileType=${this.state.item.fileExtension}%26fileName=${this.state.item.docTitle}`;
          let mailUrl = window.location.origin + downloadurl;
          let mailbody = `Title: ${encodeURIComponent(this.state.item.docTitle)}%0D%0DUrl: ${mailUrl}%0D%0DFor access to iMedical Search, please contact iMedical Search Team `;
          let mailref = `mailto:${this.state.item.contactInformation}?Subject=iMedical Search Document: ${encodeURIComponent(this.state.item.docTitle)}&body=${mailbody}`;
          //this.documentUrl(url);
          return (
            <div className="doc-card-inner">
              <div className="doc-row header-row">
                {/* <div className="left-icons">
                  <div className="checkbox-outline" data-size="M" data-state="Enabled">
                    <input type="checkbox" value={this.state.item.docTitle} key={this.state.item.docID + Math.random()} onChange={() => this.props.handelCitationSelect(this.state.documentIndex, this.props.item, this.props.itemTeaser)} checked={this.props.isChecked} style={{ cursor: "pointer", width: "14px", height: "14px" }}  />
                  </div>
                  <div className="small-square">
                    <img src={this.state.collapsed ? JJ_Icon_expandIcon : JJ_Icon_collapseIcon} alt="expand/collapse-icon" width={14} height={14} onClick={this.props.handleExpandCollapse} style={{ marginTop: this.props.customWidth < 600 ? "35%" : null, cursor: "pointer" }} />
                  </div>
                </div> */}
                <div className="doc-title">
                  <a
                    id="docdata"
                    href={window.location.origin + this.urlGenerator(this.state.item)}
                    target="_blank"
                    onClick={this.indexData}
                    data-title={this.state.item.docTitle}
                    data-products={this.state.item.tempJNJDrugs}
                    data-docnumber={this.state.item.domain}
                    data-contentsource={this.state.item.domain}
                    data-docid={this.state.item.searchID}
                    data-doctype={this.state.item.docType}
                    data-docurl={this.urlGenerator(this.state.item)}
                    data-doclastmodified={this.state.item.createdDate}
                    data-orderedby={orderedBy}
                    data-orderedfor={orderedFor}
                  >
                    {this.state.documentIndex}.{" "}{this.state.item.docTitle}
                  </a>
                </div>
              </div>
              {!this.state.collapsed ? (<>
                {/* Description */}
                {this.props.itemTeaser !== undefined &&
                  this.props.itemTeaser.length > 0 && (
                    <div className="doc-row description-row">
                      <div className="description">
                        {this.convertToHtml(
                          this.generateDocumentTeaser(this.props.itemTeaser)
                        )}
                      </div>
                    </div>
                  )}
                {/* Metadata two-column grid */}
                <div className="doc-row meta-row meta-data-row-bgcolor">
                  <div className="meta-column">
                    {this.state.item.subCategoryTA && (
                      <div className="meta-item">
                        <span className="meta-label">Category:</span>
                        <span className="meta-value">{this.state.item.subCategoryTA}</span>
                      </div>)}
                    {this.state.item.product !== undefined &&
                      this.state.item.product.length > 0 && (
                        <div className="meta-item">
                          <span className="meta-label">Product: </span>
                          <span className="meta-value">{GenerateArrayStrings(this.state.item.product)}</span>
                        </div>
                      )}
                    {this.state.item.genericProduct && (
                      <div className="meta-item">
                        <span className="meta-label">Generic Product: </span>
                        <span className="meta-value">{this.state.item.genericProduct}</span>
                      </div>
                    )}
                    {this.state.item.publishedDate && (
                      <div className="meta-item">
                        <span className="meta-label">Published Date </span>
                        <span className="meta-value">{moment(this.state.item.publishedDate).format("D-MMM-YYYY")}{" "}</span>
                      </div>
                    )}
                  </div>
                  <div className="meta-column">
                    {this.state.item.docType && (
                      <div className="meta-item">
                        <span className="meta-label">Document Type:</span>
                        <span className="meta-value">{this.state.item.docType}  </span>
                      </div>
                    )}
                    {this.state.item.contactInformation && (
                      <div className="meta-item">
                        <span className="meta-label" >
                          Contact:</span>
                        <span className="meta-value"><a href={mailref}>iMedical Insights Team</a></span>
                      </div>
                    )}
                    <div className="meta-item">
                      <span className="meta-label">Status: </span>
                      <span className="meta-value">Published</span>
                    </div>
                    <div className="meta-item">
                      <span className="meta-label">Content Source: </span>
                      <span className="meta-value">IMedical Digest (iMedical Insights)</span>
                    </div>
                  </div>
                </div>
              </>) : null}
            </div>
          );
        }
        else if (this.state.item.domain === "MIAs") {
          //let userid=localStorage.getItem('username').toLowerCase().replace(/"/g,'').split('@')[0]
          let url = `${this.state.item.downloadUrl}`;
          // let downloadurl = `/api/dcs-spo/download?connID=${this.state.item.connID}%26csID=${this.state.item.csID}%26docID=${this.state.item.docID}%26fileType=${this.state.item.fileExtension}%26fileName=${this.state.item.docTitle}`
          // let downloadurl = `${this.state.downloadUrl.replaceAll('&','%26')}%26fileName=${this.state.item.docTitle}`//&fileName=${this.state.item.docTitle}
          // let mailUrl = window.location.origin + downloadurl
          // let mailbody = `Title: ${this.state.item.docTitle}%0D%0DUrl: ${mailUrl}%0D%0DFor access to iMedical Search, please contact iMedical Search Team `
          // let mailref = `mailto:${this.state.item.contactEmail}?Subject=iMedical Search Document: ${this.state.item.docTitle}&body=${mailbody}`
          //this.documentUrl(url);
          return (
            <div className="doc-card-inner">
              <div className="doc-row header-row">
                {/* <div className="left-icons">
                  <div className="checkbox-outline" data-size="M" data-state="Enabled">
                    <input type="checkbox" value={this.state.item.docTitle} key={this.state.item.docID + Math.random()} onChange={() => this.props.handelCitationSelect(this.state.documentIndex, this.props.item, this.props.itemTeaser)} checked={this.props.isChecked} style={{ cursor: "pointer", width: "14px", height: "14px" }}  />
                  </div>
                  <div className="small-square">
                    <img src={this.state.collapsed ? JJ_Icon_expandIcon : JJ_Icon_collapseIcon} alt="expand/collapse-icon" width={14} height={14} onClick={this.props.handleExpandCollapse} style={{ marginTop: this.props.customWidth < 600 ? "35%" : null, cursor: "pointer" }} />
                  </div>
                </div> */}
                <div className="doc-title">
                  <a
                    id="docdata"
                    href={window.location.origin + this.urlGenerator(this.state.item)}
                    target="_blank"
                    onClick={this.indexData}
                    data-title={this.state.item.docTitle}
                    data-products={this.state.item.tempJNJDrugs}
                    data-docnumber={this.state.item.domain}
                    data-contentsource={this.state.item.domain}
                    data-docid={this.state.item.searchID}
                    data-doctype={this.state.item.docType}
                    data-docurl={this.urlGenerator(this.state.item)}
                    data-doclastmodified={this.state.item.createdDate}
                    data-orderedby={orderedBy}
                    data-orderedfor={orderedFor}
                  >
                    {this.state.documentIndex}.{" "}{this.state.item.docTitle}
                  </a>
                </div>
              </div>
              {!this.state.collapsed ? (<>
                {/* Description */}
                {this.props.itemTeaser !== undefined &&
                  this.props.itemTeaser.length > 0 && (
                    <div className="doc-row description-row">
                      <div className="description">
                        {this.convertToHtml(
                          this.generateDocumentTeaser(this.props.itemTeaser)
                        )}
                      </div>
                    </div>
                  )}
                {/* Metadata two-column grid */}
                <div className="doc-row meta-row meta-data-row-bgcolor">
                  <div className="meta-column">
                    <div className="meta-item">
                      <span className="meta-label">Authors: </span>
                      <span className="meta-value"> {GenerateArrayStrings([
                        "Ute Richarz",
                        "on behalf of Global Medical Affairs",
                      ])}</span>
                    </div>
                    {this.state.item.product !== undefined &&
                      this.state.item.product.length > 0 && (
                        <div className="meta-item">
                          <span className="meta-label">Products: </span>
                          <span className="meta-value">{GenerateArrayStrings(this.state.item.product)}</span>
                        </div>
                      )}
                    {this.state.item.publishedDate !== undefined &&
                      this.state.item.publishedDate.length > 0 && (
                        <div className="meta-item">
                          <span className="meta-label">Date: </span>
                          <span className="meta-value">{moment(this.state.item.publishedDate).format("D-MMM-YYYY")}</span>
                        </div>
                      )}
                    <div className="meta-item">
                      <span className="meta-label">Source: </span>
                      <span className="meta-value">Global Medical Affairs</span>
                    </div>
                  </div>
                  <div className="meta-column">
                    {this.state.item.docType &&
                      this.state.item.docType !== undefined &&
                      this.state.item.docType.length > 0 && (
                        <div className="meta-item">
                          <span className="meta-label">Document Type: </span>
                          <span className="meta-value">{this.state.item.docType}</span>
                        </div>
                      )}
                    <div className="meta-item">
                      <span className="meta-label">Publication Status: </span>
                      <span className="meta-value">Published</span>
                    </div>
                    {this.state.item.languages !== undefined &&
                      this.state.item.languages.length > 0 ? (
                      <div className="meta-item">
                        <span className="meta-label">Language</span>
                        <span className="meta-value">
                          {this.state.item.languages}
                        </span>
                      </div>
                    ) : (
                      <div className="PHM-MetaDataProperty">
                        <div className="meta-value" style={{ display: "block" }}>
                          <label>Language:&nbsp;</label>
                          <b>
                            <span className="meta-value">English</span>
                          </b>
                        </div>
                      </div>
                    )}
                    {this.state.item.csName && (
                      <div className="meta-item">
                        <span className="meta-label">Content Source: </span>
                        <span className="meta-value">{this.state.item.csName}</span>
                      </div>
                    )}
                    <div className="meta-item">
                      <span className="meta-label">Status: </span>
                      <span className="meta-value">Approved Effective</span>
                    </div>
                  </div>
                </div>
              </>) : null}
            </div>
          );
        }
        else if (this.state.item.domain === "PERC") {
          let url = `${this.state.item.downloadUrl}`;
          let mailref = `mailto:${"lshea4@its.jnj.com"}`;
          //this.documentUrl(url);
          return (
            <div className="doc-card-inner">
              <div className="doc-row header-row">
                {/* <div className="left-icons">
                  <div className="checkbox-outline" data-size="M" data-state="Enabled">
                    <input type="checkbox" value={this.state.item.docTitle} key={this.state.item.docID + Math.random()} onChange={() => this.props.handelCitationSelect(this.state.documentIndex, this.props.item, this.props.itemTeaser)} checked={this.props.isChecked} style={{ cursor: "pointer", width: "14px", height: "14px" }}  />
                  </div>
                  <div className="small-square">
                    <img src={this.state.collapsed ? JJ_Icon_expandIcon : JJ_Icon_collapseIcon} alt="expand/collapse-icon" width={14} height={14} onClick={this.props.handleExpandCollapse} style={{ marginTop: this.props.customWidth < 600 ? "35%" : null, cursor: "pointer" }} />
                  </div>
                </div> */}
                <div className="doc-title">
                  <a
                    id="docdata"
                    href={window.location.origin + this.urlGenerator(this.state.item)}
                    target="_blank"
                    onClick={this.indexData}
                    data-title={this.state.item.docTitle}
                    data-products={this.state.item.tempJNJDrugs}
                    data-docnumber={this.state.item.domain}
                    data-contentsource={this.state.item.domain}
                    data-docid={this.state.item.searchID}
                    data-doctype={this.state.item.docType}
                    data-docurl={this.urlGenerator(this.state.item)}
                    data-doclastmodified={this.state.item.createdDate}
                    data-orderedby={orderedBy}
                    data-orderedfor={orderedFor}
                  >
                    {this.state.documentIndex}.{" "}{this.state.item.docTitle}
                  </a>
                </div>
              </div>
              {!this.state.collapsed ? (<>
                {/* Description */}
                {this.props.itemTeaser !== undefined &&
                  this.props.itemTeaser.length > 0 && (
                    <div className="doc-row description-row">
                      <div className="description">
                        {this.convertToHtml(
                          this.generateDocumentTeaser(this.props.itemTeaser)
                        )}
                      </div>
                    </div>
                  )}
                {/* Metadata two-column grid */}
                <div className="doc-row meta-row meta-data-row-bgcolor">
                  <div className="meta-column">
                    {this.state.item.owner !== undefined &&
                      this.state.item.owner.length > 0 && (
                        <div className="meta-item">
                          <span className="meta-label">Authors: </span>
                          <span className="meta-value"><a href={mailref}>
                            {GenerateArrayStrings([
                              "Lisa Shea",
                              "on behalf of JSA Patient Engagement",
                            ])}
                          </a>
                          </span>
                        </div>
                      )}
                    {this.state.item.ta !== undefined &&
                      this.state.item.ta.length > 0 && (
                        <div className="meta-item">
                          <span className="meta-label">Therapeutic Area: </span>
                          <span className="meta-value">{this.state.item.ta}</span>
                        </div>
                      )}
                    {this.state.item.createdDate !== undefined &&
                      this.state.item.createdDate.length > 0 && (
                        <div className="meta-item">
                          <span className="meta-label">Date: </span>
                          <span className="meta-value">{moment(this.state.item.createdDate).format("D-MMM-YYYY")}</span>
                        </div>
                      )}
                    {this.state.item.csName !== undefined &&
                      this.state.item.csName.length > 0 && (
                        <div className="meta-item">
                          <span className="meta-label">Content Source: </span>
                          <span className="meta-value">{this.state.item.csName}</span>
                        </div>
                      )}
                  </div>
                  <div className="meta-column">
                    <div className="meta-item">
                      <span className="meta-label">Document Type: </span>
                      <span className="meta-value">Patient Engagement Final Reports</span>
                    </div>
                    {this.state.item.type !== undefined &&
                      this.state.item.type.length > 0 && (
                        <div className="meta-item">
                          <span className="meta-label">Document SubType: </span>
                          <span className="meta-value">{this.state.item.docType}</span>
                        </div>
                      )}
                    <div className="meta-item">
                      <span className="meta-label">Status: </span>
                      <span className="meta-value" >Approved Effective</span>
                    </div>
                  </div>
                </div>
              </>) : null}
            </div>
          );

        }
        else if (this.state.item.domain === "2WIRE") {
          let url = `${this.state.item.downloadUrl}`;
          //this.documentUrl(url);
          return (
            <div className="doc-card-inner">
              <div className="doc-row header-row">
                {/* <div className="left-icons">
                  <div className="checkbox-outline" data-size="M" data-state="Enabled">
                    <input type="checkbox" value={this.state.item.docTitle} key={this.state.item.docID + Math.random()} onChange={() => this.props.handelCitationSelect(this.state.documentIndex, this.props.item, this.props.itemTeaser)} checked={this.props.isChecked} style={{ cursor: "pointer", width: "14px", height: "14px" }}  />
                  </div>
                  <div className="small-square">
                    <img src={this.state.collapsed ? JJ_Icon_expandIcon : JJ_Icon_collapseIcon} alt="expand/collapse-icon" width={14} height={14} onClick={this.props.handleExpandCollapse} style={{ marginTop: this.props.customWidth < 600 ? "35%" : null, cursor: "pointer" }} />
                  </div>
                </div> */}
                <div className="doc-title">
                  <a
                    id="docdata"
                    href={window.location.origin + this.urlGenerator(this.state.item)}
                    target="_blank"
                    onClick={this.indexData}
                    data-title={this.state.item.docTitle}
                    data-products={this.state.item.tempJNJDrugs}
                    data-docnumber={this.state.item.domain}
                    data-contentsource={this.state.item.domain}
                    data-docid={this.state.item.searchID}
                    data-doctype={this.state.item.docType}
                    data-docurl={this.urlGenerator(this.state.item)}
                    data-doclastmodified={this.state.item.createdDate}
                    data-orderedby={orderedBy}
                    data-orderedfor={orderedFor}
                  >
                    {this.state.documentIndex}.{" "}{this.state.item.docTitle}
                  </a>
                </div>
              </div>
              {!this.state.collapsed ? (<>
                {/* Description */}
                {this.props.itemTeaser !== undefined &&
                  this.props.itemTeaser.length > 0 && (
                    <div className="doc-row description-row">
                      <div className="description">
                        {this.convertToHtml(
                          this.generateDocumentTeaser(this.props.itemTeaser)
                        )}
                      </div>
                    </div>
                  )}
                {/* Metadata two-column grid */}
                <div className="doc-row meta-row meta-data-row-bgcolor">
                  <div className="meta-column">
                    {this.state.item.description && (
                      <div className="meta-item">
                        <span className="meta-label">Brief Summary: </span>
                        <span className="meta-value" style={{ wordWrap: "break-word" }}>{this.state.item.description}</span>
                      </div>
                    )}
                    {this.state.item.languages ? (
                      <div className="meta-item">
                        <span className="meta-label">Language: </span>
                        <span className="meta-value">{this.state.item.languages}</span>
                      </div>
                    ) : (
                      <div className="meta-item">
                        <span className="meta-label">Language: </span>
                        <span className="meta-value">English</span>
                      </div>
                    )}
                    {this.state.item.franchise && (
                      <div className="meta-item">
                        <span className="meta-label">Franchise: </span>
                        <span className="meta-value">{this.state.item.franchise}</span>
                      </div>
                    )}
                    {this.state.item.product !== undefined &&
                      this.state.item.product.length > 0 && (
                        <div className="meta-item">
                          <span className="meta-label">Product: </span>
                          <span className="meta-value">{GenerateArrayStrings(this.state.item.product)}</span>
                        </div>
                      )}
                    {this.state.item.year && (
                      <div className="meta-item">
                        <span className="meta-label">Date: </span>
                        <span className="meta-value">{this.state.item.year}</span>
                      </div>
                    )}
                  </div>
                  <div className="meta-column">
                    {this.state.item.docType !== undefined &&
                      this.state.item.docType.length > 0 && (
                        <div className="meta-item">
                          <span className="meta-label">Document Type: </span>
                          <span className="meta-value">{this.state.item.docType}
                          </span>
                        </div>
                      )}
                    {this.state.item.owner && (
                      <div className="meta-item">
                        <span className="meta-label">Owner: </span>
                        <span className="meta-value">{this.state.item.owner} - Global MA Immunology Support</span>
                      </div>
                    )}
                    <div className="meta-item">
                      <span className="meta-label">Content Source: </span>
                      <span className="meta-value">2WIRE</span>
                    </div>
                    <div className="meta-item">
                      <span className="meta-label">Status: </span>
                      <span className="meta-value">Approved Effective</span>
                    </div>
                  </div>
                </div>
              </>) : null}
            </div>
          );
        }
        else if (this.state.item.domain === "CMIR") {
          // For Slide Decks
          let isAppFiltIsSlideDecks = false;
          this.props.appliedFilters.forEach((x) => {
            if (x.includes("Slide Decks")) {
              isAppFiltIsSlideDecks = true;
            }
          });
          //////////
          //console.log(this.state.item)
          //let userid=localStorage.getItem('username').toLowerCase().replace(/"/g,'').split('@')[0]
          let url;
          if (this.state.item.fileExtension !== "pdf") {
            url = `/api/dcs-vv/download?connID=${this.state.item.connID}&csID=${this.state.item.csID}&docID=${this.state.item.docID}&fileType=${this.state.item.fileExtension}&docVer=${this.state.item.majorVersionNumber}&fileName=${this.state.item.docTitle}`;
          } else {
            url = `/api/dcs-vv/download?connID=${this.state.item.connID}&csID=${this.state.item.csID}&docID=${this.state.item.docID}&fileType=${this.state.item.fileExtension}&fileName=${this.state.item.docTitle}`;
          }
          if (this.state.item.status === "Approved Needs Review") {
            url = url + `&docState=anr`;
          }
          if (
            this.state.item.connID !== undefined &&
            this.state.item.csID !== undefined &&
            this.state.item.docID !== undefined &&
            this.state.item.fileExtension !== undefined &&
            this.state.item.majorVersionNumber !== undefined
          ) {
            //this.documentUrl(url);
          }
          return (
            <div className="doc-card-inner">
              <div className="doc-row header-row">
                {/* <div className="left-icons">
                  <div className="checkbox-outline" data-size="M" data-state="Enabled">
                    <input type="checkbox" value={this.state.item.docTitle} key={this.state.item.docID + Math.random()} onChange={() => this.props.handelCitationSelect(this.state.documentIndex, this.props.item, this.props.itemTeaser)} checked={this.props.isChecked} style={{ cursor: "pointer", width: "14px", height: "14px" }}  />
                  </div>
                  <div className="small-square">
                    <img src={this.state.collapsed ? JJ_Icon_expandIcon : JJ_Icon_collapseIcon} alt="expand/collapse-icon" width={14} height={14} onClick={this.props.handleExpandCollapse} style={{ marginTop: this.props.customWidth < 600 ? "35%" : null, cursor: "pointer" }} />
                  </div>
                </div> */}
                <div className="doc-title">
                  <a
                    id="docdata"
                    href={window.location.origin + this.urlGenerator(this.state.item)}
                    target="_blank"
                    onClick={this.indexData}
                    data-title={this.state.item.docTitle}
                    data-products={this.state.item.tempJNJDrugs}
                    data-docnumber={this.state.item.documentNumber}
                    data-contentsource={this.state.item.domain}
                    data-docid={this.state.item.searchID}
                    data-doctype={this.state.item.docType}
                    data-docurl={this.urlGenerator(this.state.item)}
                    data-doclastmodified={this.state.item.createdDate}
                    data-orderedby={orderedBy}
                    data-orderedfor={orderedFor}
                  >
                    {this.state.documentIndex}.{" "}{this.state.item.docTitle}
                  </a>
                </div>
              </div>
              {!this.state.collapsed ? (<>
                {/* Description */}
                {this.props.itemTeaser !== undefined &&
                  this.props.itemTeaser.length > 0 && (
                    <div className="doc-row description-row">
                      <div className="description">
                        {this.convertToHtml(
                          this.generateDocumentTeaser(this.props.itemTeaser)
                        )}
                      </div>
                    </div>
                  )}
                {/* Metadata two-column grid */}
                <div className="doc-row meta-row meta-data-row-bgcolor">
                  <div className="meta-column">
                    {this.state.item.authors !== undefined &&
                      this.state.item.authors.length > 0 ? (
                      <div className="meta-item">
                        <span className="meta-label">Authors: </span>
                        <span className="meta-value">{getVarType(this.state.item.authors) !== "Array"
                          ? this.state.item.authors
                          : GenerateArrayStrings(this.state.item.authors)}</span>
                      </div>
                    ) : (
                      this.state.item.owner && (
                        <div className="meta-item">
                          <span className="meta-label">Authors: </span>
                          <span className="meta-value">{this.state.item.owner}</span>
                        </div>)
                    )}
                    {this.state.item.product !== undefined &&
                      this.state.item.product.length > 0 && (
                        <div className="meta-item">
                          <span className="meta-label">Products: </span>
                          <span className="meta-value">{GenerateArrayStrings(this.state.item.product)}</span>
                        </div>
                      )}
                    {this.state.item.languages ? (
                      <div className="meta-item">
                        <span className="meta-label">Language: </span>
                        <span className="meta-value">{this.state.item.languages}</span>
                      </div>
                    ) : (
                      <div className="meta-item">
                        <span className="meta-label">Language: </span>
                        <span className="meta-value">English</span>
                      </div>)
                    }
                    {this.state.item.countries !== undefined &&
                      this.state.item.countries.length > 0 && (
                        <div className="meta-item">
                          <span className="meta-label">Country: </span>
                          <span className="meta-value">{GenerateArrayStrings(this.state.item.countries)}</span>
                        </div>
                      )}
                    {this.state.item.documentNumber && (
                      <div className="meta-item">
                        <span className="meta-label">Document Number: </span>
                        <span className="meta-value">{this.state.item.documentNumber}
                        </span>
                      </div>
                    )}
                  </div>
                  <div className="meta-column">
                    {modifiedDate &&
                      this.state.item.modifiedDate !== undefined &&
                      this.state.item.modifiedDate.length > 0 && (
                        <div className="meta-item">
                          <span className="meta-label">Last Updated: </span>
                          <span className="meta-value">{modifiedDate}</span>
                        </div>
                      )}
                    {this.state.item.docType !== undefined &&
                      this.state.item.docType.length > 0 &&
                      !isAppFiltIsSlideDecks && (
                        <div className="meta-item">
                          <span className="meta-label">Document Type: </span>
                          <span className="meta-value">{this.state.item.docType}</span>
                        </div>
                      )}
                    <div className="meta-item">
                      <span className="meta-label">Content Source: </span>
                      <span className="meta-value">iMedical Knowledge Vault</span>
                    </div>
                    {this.state.item.status && (
                      <div className="meta-item">
                        <span className="meta-label">Status: </span>
                        <span className="meta-value">Approved Effective
                        </span>
                      </div>
                    )}
                  </div>
                </div>
              </>) : null}
            </div>
          );
        }
        else if (this.state.item.domain === "EmeaEPs") {
          // For Slide Decks
          let isAppFiltIsSlideDecks = false;
          this.props.appliedFilters.forEach((x) => {
            if (x.includes("Slide Decks")) {
              isAppFiltIsSlideDecks = true;
            }
          });
          //////////
          //console.log(this.state.item)
          //let userid=localStorage.getItem('username').toLowerCase().replace(/"/g,'').split('@')[0]
          let url;
          //dcs-spo/download?connID=${connID}&csID=${csID}&docID=${docID}&fileType=${fileType}&fileName=${fileName}`
          if (this.state.item.fileExtension !== "pdf") {
            url = `/api/dcs-spo/download?connID=${this.state.item.connID}&csID=${this.state.item.csID}&docID=${this.state.item.docID}&fileType=${this.state.item.fileExtension}&fileName=${this.state.item.docTitle}`;
          } else {
            url = `/api/dcs-spo/download?connID=${this.state.item.connID}&csID=${this.state.item.csID}&docID=${this.state.item.docID}&fileType=${this.state.item.fileExtension}`;
          }
          if (this.state.item.status === "Approved Needs Review") {
            url = url + `&docState=anr`;
          }
          if (
            this.state.item.connID !== undefined &&
            this.state.item.csID !== undefined &&
            this.state.item.docID !== undefined &&
            this.state.item.fileExtension !== undefined &&
            this.state.item.majorVersionNumber !== undefined
          ) {
            //this.documentUrl(url);
          }
          return (
            <div className="doc-card-inner">
              <div className="doc-row header-row">
                {/* <div className="left-icons">
                  <div className="checkbox-outline" data-size="M" data-state="Enabled">
                    <input type="checkbox" value={this.state.item.docTitle} key={this.state.item.docID + Math.random()} onChange={() => this.props.handelCitationSelect(this.state.documentIndex, this.props.item, this.props.itemTeaser)} checked={this.props.isChecked} style={{ cursor: "pointer", width: "14px", height: "14px" }}  />
                  </div>
                  <div className="small-square">
                    <img src={this.state.collapsed ? JJ_Icon_expandIcon : JJ_Icon_collapseIcon} alt="expand/collapse-icon" width={14} height={14} onClick={this.props.handleExpandCollapse} style={{ marginTop: this.props.customWidth < 600 ? "35%" : null, cursor: "pointer" }} />
                  </div>
                </div> */}
                <div className="doc-title">
                  <a
                    id="docdata"
                    href={window.location.origin + this.urlGenerator(this.state.item)}
                    target="_blank"
                    onClick={this.indexData}
                    data-title={this.state.item.docTitle}
                    data-products={this.state.item.tempJNJDrugs}
                    data-docnumber={this.state.item.documentNumber}
                    data-contentsource={this.state.item.domain}
                    data-docid={this.state.item.searchID}
                    data-doctype={this.state.item.docType}
                    data-docurl={this.urlGenerator(this.state.item)}
                    data-doclastmodified={this.state.item.createdDate}
                    data-orderedby={orderedBy}
                    data-orderedfor={orderedFor}
                  >
                    {this.state.documentIndex}.{" "}{this.state.item.docTitle}
                  </a>
                </div>
              </div>
              {!this.state.collapsed ? (<>
                {/* Description */}
                {this.props.itemTeaser !== undefined &&
                  this.props.itemTeaser.length > 0 && (
                    <div className="doc-row description-row">
                      <div className="description">
                        {this.convertToHtml(
                          this.generateDocumentTeaser(this.props.itemTeaser)
                        )}
                      </div>
                    </div>
                  )}
                {/* Metadata two-column grid */}
                <div className="doc-row meta-row meta-data-row-bgcolor">
                  <div className="meta-column">
                    {this.state.item.owner && (
                      <div className="meta-item">
                        <span className="meta-label">Authors: </span>
                        <span className="meta-value">{this.state.item.owner}
                        </span>
                      </div>
                    )}
                    {this.state.item.product !== undefined &&
                      this.state.item.product.length > 0 && (
                        <div className="meta-item">
                          <span className="meta-label">Products: </span>
                          <span className="meta-value">{GenerateArrayStrings(this.state.item.product)}</span>
                        </div>
                      )}
                    {this.state.item.languages ? (
                      <div className="meta-item">
                        <span className="meta-label">Language: </span>
                        <span className="meta-value">{GenerateArrayStrings(this.state.item.languages)}</span>
                      </div>
                    ) : (
                      <div className="meta-item">
                        <span className="meta-label">Language: </span>
                        <span className="meta-value">English</span>
                      </div>
                    )}
                  </div>
                  <div className="meta-column">
                    {this.state.item.countries !== undefined &&
                      this.state.item.countries.length > 0 && (
                        <div className="meta-item">
                          <span className="meta-label">Country: </span>
                          <span className="meta-value">{GenerateArrayStrings(this.state.item.countries)}</span>
                        </div>
                      )}
                    {this.state.item.ta !== undefined &&
                      this.state.item.ta.length > 0 && (
                        <div className="meta-item">
                          <span className="meta-label">Therapeutic Area: </span>
                          <span className="meta-value">{this.state.item.ta}</span>
                        </div>
                      )}
                    {this.state.item.type !== undefined &&
                      this.state.item.type.length > 0 && (
                        <div className="meta-item">
                          <span className="meta-label">Document Type: </span>
                          <span className="meta-value">{this.state.item.type}</span>
                        </div>
                      )}
                    {this.state.item.clinicalTrialName !== undefined &&
                      this.state.item.clinicalTrialName.length > 0 && (
                        <div className="meta-item">
                          <span className="meta-label">Clinical Trial Name: </span>
                          <span className="meta-value">{this.state.item.clinicalTrialName}
                          </span>
                        </div>
                      )}
                    {this.state.item.status && (
                      <div className="meta-item">
                        <span className="meta-label">Status: </span>
                        <span className="meta-value">Approved Effective</span>
                      </div>
                    )}
                  </div>
                </div>
              </>) : null}
            </div>
          );
        }
        else if (true) {
          // For Slide Decks
          let isAppFiltIsSlideDecks = false;
          this.props.appliedFilters.forEach((x) => {
            if (x.includes("Slide Decks")) {
              isAppFiltIsSlideDecks = true;
            }
          });
          //////////
          //console.log(this.state.item)
          //let userid=localStorage.getItem('username').toLowerCase().replace(/"/g,'').split('@')[0]
          let url;
          if (this.state.item.fileExtension !== "pdf") {
            url = `/api/dcs-vv/download?connID=${this.state.item.connID}&csID=${this.state.item.csID}&docID=${this.state.item.docID}&fileType=${this.state.item.fileExtension}&docVer=${this.state.item.majorVersionNumber}&fileName=${this.state.item.docTitle}`;
          } else {
            url = `/api/dcs-vv/download?connID=${this.state.item.connID}&csID=${this.state.item.csID}&docID=${this.state.item.docID}&fileType=${this.state.item.fileExtension}&fileName=${this.state.item.docTitle}`;
          }
          if (this.state.item.status === "Approved Needs Review") {
            url = url + `&docState=anr`;
          }
          if (
            this.state.item.connID !== undefined &&
            this.state.item.csID !== undefined &&
            this.state.item.docID !== undefined &&
            this.state.item.fileExtension !== undefined &&
            this.state.item.majorVersionNumber !== undefined
          ) {
            //this.documentUrl(url);
          }
          return (
            <div className="doc-card-inner">
              <div className="doc-row header-row">
                {/* <div className="left-icons">
                  <div className="checkbox-outline" data-size="M" data-state="Enabled">
                    <input type="checkbox" value={this.state.item.docTitle} key={this.state.item.docID + Math.random()} onChange={() => this.props.handelCitationSelect(this.state.documentIndex, this.props.item, this.props.itemTeaser)} checked={this.props.isChecked} style={{ cursor: "pointer", width: "14px", height: "14px" }}  />
                  </div>
                  <div className="small-square">
                    <img src={this.state.collapsed ? JJ_Icon_expandIcon : JJ_Icon_collapseIcon} alt="expand/collapse-icon" width={14} height={14} onClick={this.props.handleExpandCollapse} style={{ marginTop: this.props.customWidth < 600 ? "35%" : null, cursor: "pointer" }} />
                  </div>
                </div> */}
                <div className="doc-title">
                  <a
                    id="docdata"
                    href={window.location.origin + this.urlGenerator(this.state.item)}
                    target="_blank"
                    onClick={this.indexData}
                    data-title={this.state.item.docTitle}
                    data-products={this.state.item.tempJNJDrugs}
                    data-docnumber={this.state.item.documentNumber}
                    data-contentsource={this.state.item.domain}
                    data-docid={this.state.item.searchID}
                    data-doctype={this.state.item.docType}
                    data-docurl={this.urlGenerator(this.state.item)}
                    data-doclastmodified={this.state.item.createdDate}
                    data-orderedby={orderedBy}
                    data-orderedfor={orderedFor}
                  >
                    {this.state.documentIndex}.{" "}{this.state.item.docTitle}
                  </a>
                </div>
              </div>
              {!this.state.collapsed ? (<>
                {/* Description */}
                {this.props.itemTeaser !== undefined &&
                  this.props.itemTeaser.length > 0 && (
                    <div className="doc-row description-row">
                      <div className="description">
                        {this.convertToHtml(
                          this.generateDocumentTeaser(this.props.itemTeaser)
                        )}
                      </div>
                    </div>
                  )}
                {/* Metadata two-column grid */}
                <div className="doc-row meta-row meta-data-row-bgcolor">
                  <div className="meta-column">
                    {this.state.item.authors !== undefined &&
                      this.state.item.authors.length > 0 ? (
                      <div className="meta-item">
                        <span className="meta-label">Authors: </span>
                        <span className="meta-value">{getVarType(this.state.item.authors) !== "Array"
                          ? this.state.item.authors
                          : GenerateArrayStrings(this.state.item.authors)}</span>
                      </div>
                    ) : (<div className="meta-item">
                      <span className="meta-label">Authors: </span>
                      <span className="meta-value">{this.state.item.owner}</span>
                    </div>
                    )}
                    {this.state.item.congressName !== undefined &&
                      this.state.item.congressName.length > 0 && (
                        <div className="meta-item">
                          <span className="meta-label">Congress Name: </span>
                          <span className="meta-value">{GenerateArrayStrings(
                            this.state.item.congressName
                          )}</span>
                        </div>
                      )}
                    {this.state.item.languages ? (
                      <div className="meta-item">
                        <span className="meta-label">Language: </span>
                        <span className="meta-value">
                          {getVarType(this.state.item.languages) !== "Array"
                            ? this.state.item.languages
                            : GenerateArrayStrings(this.state.item.languages)}
                        </span>
                      </div>
                    ) : (
                      <div className="meta-item">
                        <span className="meta-label">Language: </span>
                        <span className="meta-value">English</span>
                      </div>
                    )}
                    {this.state.item.countries !== undefined &&
                      this.state.item.countries.length > 0 && (
                        <div className="meta-item">
                          <span className="meta-label">Country: </span>
                          <span className="meta-value">{GenerateArrayStrings(this.state.item.countries)}</span>
                        </div>
                      )}
                    {this.state.item.franchise && (
                      <div className="meta-item">
                        <span className="meta-label">Franchise: </span>
                        <span className="meta-value">{this.state.item.franchise}</span>
                      </div>
                    )}
                  </div>
                  <div className="meta-column">
                    {this.state.item.product !== undefined &&
                      this.state.item.product.length > 0 && (
                        <div className="meta-item">
                          <span className="meta-label">Product: </span>
                          <span className="meta-value">{GenerateArrayStrings(this.state.item.product)}</span>
                        </div>
                      )}
                    {this.state.item.year && (
                      <div className="meta-item">
                        <span className="meta-label">Date: </span>
                        <span className="meta-value">{this.state.item.year}</span>
                      </div>
                    )}
                    {this.state.item.docType !== undefined &&
                      this.state.item.docType.length > 0 &&
                      !isAppFiltIsSlideDecks && (
                        <div className="meta-item">
                          <span className="meta-label">Document Type: </span>
                          <span className="meta-value">{this.state.item.docType}</span>
                        </div>
                      )}
                    {this.state.item.owner ? (
                      <div className="meta-item">
                        <span className="meta-label">Owner: </span>
                        <span className="meta-value">{this.state.item.owner} – Global MA Immunology
                          Support</span>
                      </div>
                    ) : (
                      <div className="meta-item">
                        <span className="meta-label">Owner: </span>
                        <span className="meta-value">Global MA Immunology Support</span>
                      </div>
                    )}
                    <div className="meta-item">
                      <span className="meta-label">Content Source: </span>
                      <span className="meta-value">2WIRE</span>
                    </div>
                    {this.state.item.status && (
                      <div className="meta-item">
                        <span className="meta-label">Status: </span>
                        <span className="meta-value">Approved Effective</span>
                      </div>
                    )}
                  </div>
                </div>
              </>) : null}
            </div>
          );
        }
      }
      //#endregion
    } else {
      //#region for PubMed render
      let url = `/DocURLPubMed?sid=PMS&pmid=${this.state.item.PMID}`;
      return (
        <div>
          <div className="results-title-action-outer-wrapper">
            <span className="results-div-docTitle-wrapper">
              <span
                style={{
                  color: "#0074B0",
                  fontSize: "14px",
                  fontWeight: "bold",
                }}
              >
                {this.state.documentIndex}.{" "}
              </span>
              <span>
                <a
                  id="docdata"
                  to={{ pathname: url }}
                  target="_blank"
                  data-title={this.state.item.title}
                  data-docurl={url}
                  onClick={this.indexPubMedData}
                >
                  {this.state.item.title}
                </a>
              </span>
            </span>
          </div>
          {!this.state.collapsed ? (
            <div
              id={`docID-${this.state.documentIndex}`}
              className="citation-results-meta-property-wrapper"
            >
              {this.state.item.authors &&
                this.state.item.authors.length > 0 && (
                  <div className="PHM-MetaDataProperty">
                    <div style={{ display: "block" }}>
                      <label>Authors:&nbsp;</label>
                      <b>
                        <label>
                          {getVarType(this.state.item.authors) !== "Array"
                            ? this.state.item.authors
                            : GenerateArrayStrings(this.state.item.authors)}
                        </label>
                      </b>
                    </div>
                  </div>
                )}
              {this.state.item.publicationDate && (
                <div className="PHM-MetaDataProperty">
                  <div style={{ display: "block" }}>
                    <label>Date:&nbsp;</label>
                    <b>
                      <label>{this.state.item.publicationDate}</label>
                    </b>
                  </div>
                </div>
              )}
              {this.state.item.source && (
                <div className="PHM-MetaDataProperty">
                  <div style={{ display: "block" }}>
                    <label>Source:&nbsp;</label>
                    <b>
                      <label>
                        {this.state.item.source.name}.
                        {this.state.item.source.year};
                        {this.state.item.source.location}
                      </label>
                    </b>
                  </div>
                </div>
              )}
              {this.state.item.PMID && (
                <div className="PHM-MetaDataProperty">
                  <div style={{ display: "block" }}>
                    <label>PubMed ID:&nbsp;</label>
                    <b>
                      <label>
                        <a
                          href="javascript:void(0)"
                          title="Click this field to view the abstract in PubMed. This will appear in a new browser tab"
                          onClick={(e) =>
                            this.handlePubMedID(this.state.item.PMID)
                          }
                        >
                          {this.state.item.PMID}
                        </a>
                      </label>
                    </b>
                  </div>
                </div>
              )}
              {this.state.item.doi && (
                <div className="PHM-MetaDataProperty">
                  <div style={{ display: "block" }}>
                    <label>DOI:&nbsp;</label>
                    <b>
                      <label>
                        <a
                          href="javascript:void(0)"
                          title="Click this field to view the abstract in doi.org. This will appear in a new browser tab"
                          onClick={(e) => this.handleDOI(this.state.item.doi)}
                        >
                          {this.state.item.doi}
                        </a>
                      </label>
                    </b>
                  </div>
                </div>
              )}
              {this.state.item.language &&
                this.state.item.language !== "eng" ? (
                <div className="PHM-MetaDataProperty">
                  <div style={{ display: "block" }}>
                    <label>Language:&nbsp;</label>
                    <b>
                      <label>{this.state.item.languages}</label>
                    </b>
                  </div>
                </div>
              ) : (
                <div className="PHM-MetaDataProperty">
                  <div style={{ display: "block" }}>
                    <label>Language:&nbsp;</label>
                    <b>
                      <label>English</label>
                    </b>
                  </div>
                </div>
              )}
              {this.state.item.franchise && (
                <div className="PHM-MetaDataProperty">
                  <div style={{ display: "block" }}>
                    <label>Franchise :&nbsp;</label>
                    <b>
                      <label>{this.state.item.franchise}</label>
                    </b>
                  </div>
                </div>
              )}
              <div className="PHM-MetaDataProperty">
                <div style={{ display: "block" }}>
                  <label>Content Source:&nbsp;</label>
                  <b>
                    <label>PubMed</label>
                  </b>
                </div>
              </div>
              {(this.state.item.meshHeading ||
                this.state.item.publicationType ||
                this.state.item.chemicals) && (
                  <div className="PHM-MetaDataProperty">
                    <div style={{ display: "block" }}>
                      <DocumentDescriptor
                        meshHeading={this.state.item.meshHeading}
                        publicationType={this.state.item.publicationType}
                        substances={this.state.item.chemicals}
                      />
                    </div>
                  </div>
                )}
            </div>
          ) : null}
        </div>
      );
      //#endregion
    }
  }
}
export default DownloadDocumentResultsGenAI;